/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.0.6.0 (NJsonSchema v10.0.23.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const HOST_API_BASE_URL = new InjectionToken<string>('HOST_API_BASE_URL');

@Injectable()
export class AppBinaryObjectServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HOST_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: AppBinaryObject | undefined): Observable<AppBinaryObject> {
        let url_ = this.baseUrl + "/hostapi/AppBinaryObject/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<AppBinaryObject>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppBinaryObject>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AppBinaryObject> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppBinaryObject.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppBinaryObject>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/AppBinaryObject/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AuthenticateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HOST_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/Authenticate/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MasterAuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HOST_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllMasterAuditLog(): Observable<MasterAuditLog[]> {
        let url_ = this.baseUrl + "/hostapi/MasterAuditLog/GetAllMasterAuditLog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMasterAuditLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMasterAuditLog(<any>response_);
                } catch (e) {
                    return <Observable<MasterAuditLog[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterAuditLog[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMasterAuditLog(response: HttpResponseBase): Observable<MasterAuditLog[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterAuditLog.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterAuditLog[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMasterAuditLog(body: MasterAuditLog | undefined): Observable<MasterAuditLog> {
        let url_ = this.baseUrl + "/hostapi/MasterAuditLog/CreateMasterAuditLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMasterAuditLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMasterAuditLog(<any>response_);
                } catch (e) {
                    return <Observable<MasterAuditLog>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterAuditLog>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMasterAuditLog(response: HttpResponseBase): Observable<MasterAuditLog> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterAuditLog.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterAuditLog>(<any>null);
    }
}

@Injectable()
export class MasterDeviceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HOST_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param rtuSN (optional) 
     * @return Success
     */
    getMasterDeviceByRTU(rtuSN: string | undefined): Observable<MasterDevice> {
        let url_ = this.baseUrl + "/hostapi/MasterDevice/GetMasterDeviceByRTU?";
        if (rtuSN === null)
            throw new Error("The parameter 'rtuSN' cannot be null.");
        else if (rtuSN !== undefined)
            url_ += "rtuSN=" + encodeURIComponent("" + rtuSN) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMasterDeviceByRTU(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterDeviceByRTU(<any>response_);
                } catch (e) {
                    return <Observable<MasterDevice>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDevice>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterDeviceByRTU(response: HttpResponseBase): Observable<MasterDevice> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterDevice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDevice>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMasterDeviceById(id: number | undefined): Observable<MasterDevice> {
        let url_ = this.baseUrl + "/hostapi/MasterDevice/GetMasterDeviceById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMasterDeviceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterDeviceById(<any>response_);
                } catch (e) {
                    return <Observable<MasterDevice>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDevice>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterDeviceById(response: HttpResponseBase): Observable<MasterDevice> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterDevice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDevice>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMasterDevices(): Observable<MasterDevice[]> {
        let url_ = this.baseUrl + "/hostapi/MasterDevice/GetAllMasterDevices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMasterDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMasterDevices(<any>response_);
                } catch (e) {
                    return <Observable<MasterDevice[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDevice[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMasterDevices(response: HttpResponseBase): Observable<MasterDevice[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterDevice.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDevice[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<MasterDevice[]> {
        let url_ = this.baseUrl + "/hostapi/MasterDevice/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MasterDevice[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDevice[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MasterDevice[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterDevice.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDevice[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMasterDevicesView(): Observable<VwGetDevice[]> {
        let url_ = this.baseUrl + "/hostapi/MasterDevice/GetAllMasterDevicesView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMasterDevicesView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMasterDevicesView(<any>response_);
                } catch (e) {
                    return <Observable<VwGetDevice[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<VwGetDevice[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMasterDevicesView(response: HttpResponseBase): Observable<VwGetDevice[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VwGetDevice.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VwGetDevice[]>(<any>null);
    }

    /**
     * @param deviceId (optional) 
     * @return Success
     */
    getFirmwareVersion(deviceId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/hostapi/MasterDevice/GetFirmwareVersion?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFirmwareVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirmwareVersion(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetFirmwareVersion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMasterDeviceForEdit(id: number | undefined): Observable<MasterDevice> {
        let url_ = this.baseUrl + "/hostapi/MasterDevice/GetMasterDeviceForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMasterDeviceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterDeviceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<MasterDevice>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDevice>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterDeviceForEdit(response: HttpResponseBase): Observable<MasterDevice> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterDevice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDevice>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param type (optional) 
     * @return Success
     */
    getCount(id: number | undefined, type: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/hostapi/MasterDevice/GetCount?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDevice(body: MasterDevice | undefined): Observable<MasterDevice> {
        let url_ = this.baseUrl + "/hostapi/MasterDevice/CreateDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDevice(<any>response_);
                } catch (e) {
                    return <Observable<MasterDevice>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDevice>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDevice(response: HttpResponseBase): Observable<MasterDevice> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterDevice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDevice>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDevice(body: MasterDevice | undefined): Observable<MasterDevice> {
        let url_ = this.baseUrl + "/hostapi/MasterDevice/UpdateDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDevice(<any>response_);
                } catch (e) {
                    return <Observable<MasterDevice>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDevice>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDevice(response: HttpResponseBase): Observable<MasterDevice> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterDevice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDevice>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteDevice(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterDevice/DeleteDevice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDevice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addOrUpdateMasterDeviceAuthenticationCode(body: MasterDeviceAuthenticationCodes | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterDevice/AddOrUpdateMasterDeviceAuthenticationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateMasterDeviceAuthenticationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateMasterDeviceAuthenticationCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddOrUpdateMasterDeviceAuthenticationCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MasterDeviceConfigServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HOST_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllMasterDeviceConfig(): Observable<MasterDeviceConfiguration[]> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/GetAllMasterDeviceConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMasterDeviceConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMasterDeviceConfig(<any>response_);
                } catch (e) {
                    return <Observable<MasterDeviceConfiguration[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDeviceConfiguration[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMasterDeviceConfig(response: HttpResponseBase): Observable<MasterDeviceConfiguration[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterDeviceConfiguration.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDeviceConfiguration[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteMasterDeviceConfig(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/DeleteMasterDeviceConfig?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMasterDeviceConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMasterDeviceConfig(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteMasterDeviceConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMasterDeviceConfig(body: MasterDeviceConfiguration | undefined): Observable<MasterDeviceConfiguration> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/CreateMasterDeviceConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMasterDeviceConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMasterDeviceConfig(<any>response_);
                } catch (e) {
                    return <Observable<MasterDeviceConfiguration>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDeviceConfiguration>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMasterDeviceConfig(response: HttpResponseBase): Observable<MasterDeviceConfiguration> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterDeviceConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDeviceConfiguration>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMasterDeviceConfig(body: MasterDeviceConfiguration | undefined): Observable<MasterDeviceConfiguration> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/UpdateMasterDeviceConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMasterDeviceConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMasterDeviceConfig(<any>response_);
                } catch (e) {
                    return <Observable<MasterDeviceConfiguration>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDeviceConfiguration>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateMasterDeviceConfig(response: HttpResponseBase): Observable<MasterDeviceConfiguration> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterDeviceConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDeviceConfiguration>(<any>null);
    }

    /**
     * @param masterDeviceConfigId (optional) 
     * @return Success
     */
    getAllMasterDeviceConfigChannels(masterDeviceConfigId: number | undefined): Observable<MasterDeviceConfigurationChannel[]> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/GetAllMasterDeviceConfigChannels?";
        if (masterDeviceConfigId === null)
            throw new Error("The parameter 'masterDeviceConfigId' cannot be null.");
        else if (masterDeviceConfigId !== undefined)
            url_ += "masterDeviceConfigId=" + encodeURIComponent("" + masterDeviceConfigId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMasterDeviceConfigChannels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMasterDeviceConfigChannels(<any>response_);
                } catch (e) {
                    return <Observable<MasterDeviceConfigurationChannel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDeviceConfigurationChannel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMasterDeviceConfigChannels(response: HttpResponseBase): Observable<MasterDeviceConfigurationChannel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterDeviceConfigurationChannel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDeviceConfigurationChannel[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteMasterDeviceConfigChannel(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/DeleteMasterDeviceConfigChannel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMasterDeviceConfigChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMasterDeviceConfigChannel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteMasterDeviceConfigChannel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMasterDeviceConfigChannel(body: MasterDeviceConfigurationChannel | undefined): Observable<MasterDeviceConfigurationChannel> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/CreateMasterDeviceConfigChannel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMasterDeviceConfigChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMasterDeviceConfigChannel(<any>response_);
                } catch (e) {
                    return <Observable<MasterDeviceConfigurationChannel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDeviceConfigurationChannel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMasterDeviceConfigChannel(response: HttpResponseBase): Observable<MasterDeviceConfigurationChannel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterDeviceConfigurationChannel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDeviceConfigurationChannel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMasterDeviceConfigChannel(body: MasterDeviceConfigurationChannel | undefined): Observable<MasterDeviceConfigurationChannel> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/UpdateMasterDeviceConfigChannel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMasterDeviceConfigChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMasterDeviceConfigChannel(<any>response_);
                } catch (e) {
                    return <Observable<MasterDeviceConfigurationChannel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDeviceConfigurationChannel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateMasterDeviceConfigChannel(response: HttpResponseBase): Observable<MasterDeviceConfigurationChannel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterDeviceConfigurationChannel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDeviceConfigurationChannel>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMasterDeviceConfigMeasurement(): Observable<MasterDeviceConfigurationMeasurement[]> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/GetAllMasterDeviceConfigMeasurement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMasterDeviceConfigMeasurement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMasterDeviceConfigMeasurement(<any>response_);
                } catch (e) {
                    return <Observable<MasterDeviceConfigurationMeasurement[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDeviceConfigurationMeasurement[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMasterDeviceConfigMeasurement(response: HttpResponseBase): Observable<MasterDeviceConfigurationMeasurement[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterDeviceConfigurationMeasurement.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDeviceConfigurationMeasurement[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMasterDeviceConfigMeasurement(id: number | undefined): Observable<MasterDeviceConfigurationMeasurement[]> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/GetMasterDeviceConfigMeasurement?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMasterDeviceConfigMeasurement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterDeviceConfigMeasurement(<any>response_);
                } catch (e) {
                    return <Observable<MasterDeviceConfigurationMeasurement[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDeviceConfigurationMeasurement[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterDeviceConfigMeasurement(response: HttpResponseBase): Observable<MasterDeviceConfigurationMeasurement[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterDeviceConfigurationMeasurement.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDeviceConfigurationMeasurement[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteMasterDeviceConfigMeasurement(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/DeleteMasterDeviceConfigMeasurement?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMasterDeviceConfigMeasurement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMasterDeviceConfigMeasurement(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteMasterDeviceConfigMeasurement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMasterDeviceConfigMeasurement(body: MasterDeviceConfigurationMeasurement | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/CreateMasterDeviceConfigMeasurement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMasterDeviceConfigMeasurement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMasterDeviceConfigMeasurement(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMasterDeviceConfigMeasurement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMasterDeviceConfigMeasurement(body: MasterDeviceConfigurationMeasurement | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/UpdateMasterDeviceConfigMeasurement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMasterDeviceConfigMeasurement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMasterDeviceConfigMeasurement(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateMasterDeviceConfigMeasurement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMasterDeviceBinaryMeasurementConfig(id: number | undefined): Observable<MasterDeviceBinaryMeasurementConfig[]> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/GetMasterDeviceBinaryMeasurementConfig?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMasterDeviceBinaryMeasurementConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterDeviceBinaryMeasurementConfig(<any>response_);
                } catch (e) {
                    return <Observable<MasterDeviceBinaryMeasurementConfig[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDeviceBinaryMeasurementConfig[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterDeviceBinaryMeasurementConfig(response: HttpResponseBase): Observable<MasterDeviceBinaryMeasurementConfig[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterDeviceBinaryMeasurementConfig.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDeviceBinaryMeasurementConfig[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteMasterDeviceBinaryMeasurementConfig(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/DeleteMasterDeviceBinaryMeasurementConfig?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMasterDeviceBinaryMeasurementConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMasterDeviceBinaryMeasurementConfig(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteMasterDeviceBinaryMeasurementConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMasterDeviceBinaryMeasurementConfig(body: MasterDeviceBinaryMeasurementConfig | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/CreateMasterDeviceBinaryMeasurementConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMasterDeviceBinaryMeasurementConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMasterDeviceBinaryMeasurementConfig(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMasterDeviceBinaryMeasurementConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMasterDeviceBinaryMeasurementConfig(body: MasterDeviceBinaryMeasurementConfig | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceConfig/UpdateMasterDeviceBinaryMeasurementConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMasterDeviceBinaryMeasurementConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMasterDeviceBinaryMeasurementConfig(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateMasterDeviceBinaryMeasurementConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MasterDeviceFirmwareServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HOST_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<MasterDeviceFirmware[]> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceFirmware/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MasterDeviceFirmware[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDeviceFirmware[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MasterDeviceFirmware[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterDeviceFirmware.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDeviceFirmware[]>(<any>null);
    }

    /**
     * @param masterDeviceId (optional) 
     * @return Success
     */
    setAllInactive(masterDeviceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceFirmware/SetAllInactive?";
        if (masterDeviceId === null)
            throw new Error("The parameter 'masterDeviceId' cannot be null.");
        else if (masterDeviceId !== undefined)
            url_ += "masterDeviceId=" + encodeURIComponent("" + masterDeviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllInactive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllInactive(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAllInactive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMasterDeviceFirmwareForEdit(id: number | undefined): Observable<MasterDeviceFirmware> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceFirmware/GetMasterDeviceFirmwareForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMasterDeviceFirmwareForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterDeviceFirmwareForEdit(<any>response_);
                } catch (e) {
                    return <Observable<MasterDeviceFirmware>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDeviceFirmware>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterDeviceFirmwareForEdit(response: HttpResponseBase): Observable<MasterDeviceFirmware> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterDeviceFirmware.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDeviceFirmware>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMasterDeviceByFirmwareId(id: number | undefined): Observable<MasterDevice> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceFirmware/GetMasterDeviceByFirmwareId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMasterDeviceByFirmwareId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterDeviceByFirmwareId(<any>response_);
                } catch (e) {
                    return <Observable<MasterDevice>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDevice>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterDeviceByFirmwareId(response: HttpResponseBase): Observable<MasterDevice> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterDevice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDevice>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: MasterDeviceFirmware | undefined): Observable<MasterDeviceFirmware> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceFirmware/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MasterDeviceFirmware>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDeviceFirmware>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MasterDeviceFirmware> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterDeviceFirmware.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDeviceFirmware>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: MasterDeviceFirmware | undefined): Observable<MasterDeviceFirmware> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceFirmware/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MasterDeviceFirmware>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDeviceFirmware>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MasterDeviceFirmware> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterDeviceFirmware.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDeviceFirmware>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterDeviceFirmware/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MasterFormulaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HOST_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMasterFormulaCalculation(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/hostapi/MasterFormula/GetMasterFormulaCalculation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMasterFormulaCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterFormulaCalculation(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterFormulaCalculation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMasterFormulaUnit(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/hostapi/MasterFormula/GetMasterFormulaUnit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMasterFormulaUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterFormulaUnit(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterFormulaUnit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param measurement (optional) 
     * @param sessionTenantId (optional) 
     * @return Success
     */
    getFormulasForDropDown(measurement: string | undefined, sessionTenantId: number | undefined): Observable<GetFormulasForDropDownOutput[]> {
        let url_ = this.baseUrl + "/hostapi/MasterFormula/GetFormulasForDropDown?";
        if (measurement === null)
            throw new Error("The parameter 'measurement' cannot be null.");
        else if (measurement !== undefined)
            url_ += "measurement=" + encodeURIComponent("" + measurement) + "&"; 
        if (sessionTenantId === null)
            throw new Error("The parameter 'sessionTenantId' cannot be null.");
        else if (sessionTenantId !== undefined)
            url_ += "sessionTenantId=" + encodeURIComponent("" + sessionTenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormulasForDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormulasForDropDown(<any>response_);
                } catch (e) {
                    return <Observable<GetFormulasForDropDownOutput[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFormulasForDropDownOutput[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFormulasForDropDown(response: HttpResponseBase): Observable<GetFormulasForDropDownOutput[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetFormulasForDropDownOutput.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFormulasForDropDownOutput[]>(<any>null);
    }
}

@Injectable()
export class MasterMeterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HOST_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<VwGetMasterMeter[]> {
        let url_ = this.baseUrl + "/hostapi/MasterMeter/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<VwGetMasterMeter[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<VwGetMasterMeter[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VwGetMasterMeter[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VwGetMasterMeter.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VwGetMasterMeter[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMasterMeterForEdit(id: number | undefined): Observable<MasterMeter> {
        let url_ = this.baseUrl + "/hostapi/MasterMeter/GetMasterMeterForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMasterMeterForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterMeterForEdit(<any>response_);
                } catch (e) {
                    return <Observable<MasterMeter>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterMeter>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterMeterForEdit(response: HttpResponseBase): Observable<MasterMeter> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterMeter.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterMeter>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param sn (optional) 
     * @return Success
     */
    getCount(id: number | undefined, sn: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/hostapi/MasterMeter/GetCount?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (sn === null)
            throw new Error("The parameter 'sn' cannot be null.");
        else if (sn !== undefined)
            url_ += "sn=" + encodeURIComponent("" + sn) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMeter(body: MasterMeter | undefined): Observable<MasterMeter> {
        let url_ = this.baseUrl + "/hostapi/MasterMeter/CreateMeter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMeter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMeter(<any>response_);
                } catch (e) {
                    return <Observable<MasterMeter>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterMeter>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMeter(response: HttpResponseBase): Observable<MasterMeter> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterMeter.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterMeter>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMeter(body: MasterMeter | undefined): Observable<MasterMeter> {
        let url_ = this.baseUrl + "/hostapi/MasterMeter/UpdateMeter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMeter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMeter(<any>response_);
                } catch (e) {
                    return <Observable<MasterMeter>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterMeter>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateMeter(response: HttpResponseBase): Observable<MasterMeter> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterMeter.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterMeter>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteMeter(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterMeter/DeleteMeter?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMeter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMeter(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteMeter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MasterRTUServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HOST_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllMasterRTUs(): Observable<MasterRtu[]> {
        let url_ = this.baseUrl + "/hostapi/MasterRTU/GetAllMasterRTUs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMasterRTUs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMasterRTUs(<any>response_);
                } catch (e) {
                    return <Observable<MasterRtu[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterRtu[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMasterRTUs(response: HttpResponseBase): Observable<MasterRtu[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterRtu.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterRtu[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<VwGetMasterRtu[]> {
        let url_ = this.baseUrl + "/hostapi/MasterRTU/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<VwGetMasterRtu[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<VwGetMasterRtu[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VwGetMasterRtu[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VwGetMasterRtu.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VwGetMasterRtu[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMasterRtuForEdit(id: number | undefined): Observable<MasterRtu> {
        let url_ = this.baseUrl + "/hostapi/MasterRTU/GetMasterRtuForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMasterRtuForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterRtuForEdit(<any>response_);
                } catch (e) {
                    return <Observable<MasterRtu>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterRtu>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterRtuForEdit(response: HttpResponseBase): Observable<MasterRtu> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterRtu.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterRtu>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param sn (optional) 
     * @return Success
     */
    getCount(id: number | undefined, sn: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/hostapi/MasterRTU/GetCount?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (sn === null)
            throw new Error("The parameter 'sn' cannot be null.");
        else if (sn !== undefined)
            url_ += "sn=" + encodeURIComponent("" + sn) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRTU(body: MasterRtu | undefined): Observable<MasterRtu> {
        let url_ = this.baseUrl + "/hostapi/MasterRTU/CreateRTU";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRTU(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRTU(<any>response_);
                } catch (e) {
                    return <Observable<MasterRtu>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterRtu>><any>_observableThrow(response_);
        }));
    }

    protected processCreateRTU(response: HttpResponseBase): Observable<MasterRtu> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterRtu.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterRtu>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRTU(body: MasterRtu | undefined): Observable<MasterRtu> {
        let url_ = this.baseUrl + "/hostapi/MasterRTU/UpdateRTU";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRTU(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRTU(<any>response_);
                } catch (e) {
                    return <Observable<MasterRtu>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterRtu>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRTU(response: HttpResponseBase): Observable<MasterRtu> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterRtu.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterRtu>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    toggleStream(body: ToggleStreamInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/hostapi/MasterRTU/ToggleStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleStream(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processToggleStream(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteRTU(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterRTU/DeleteRTU?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRTU(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRTU(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteRTU(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    toggleSendCellLogs(body: ToggleSendLogsInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/hostapi/MasterRTU/ToggleSendCellLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleSendCellLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleSendCellLogs(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processToggleSendCellLogs(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setNewBatteryPercentage(body: SetBatteryPercentageInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/hostapi/MasterRTU/SetNewBatteryPercentage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNewBatteryPercentage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNewBatteryPercentage(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processSetNewBatteryPercentage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class MasterSensorDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HOST_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllDetailData(): Observable<MasterSensorDetailData[]> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/GetAllDetailData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDetailData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDetailData(<any>response_);
                } catch (e) {
                    return <Observable<MasterSensorDetailData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterSensorDetailData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDetailData(response: HttpResponseBase): Observable<MasterSensorDetailData[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterSensorDetailData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterSensorDetailData[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailDataSerialNumbersOnly(): Observable<string[]> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/GetDetailDataSerialNumbersOnly";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailDataSerialNumbersOnly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailDataSerialNumbersOnly(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetailDataSerialNumbersOnly(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param sn (optional) 
     * @return Success
     */
    getDetailDataBySerialNumber(sn: string | undefined): Observable<MasterSensorDetailData[]> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/GetDetailDataBySerialNumber?";
        if (sn === null)
            throw new Error("The parameter 'sn' cannot be null.");
        else if (sn !== undefined)
            url_ += "sn=" + encodeURIComponent("" + sn) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailDataBySerialNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailDataBySerialNumber(<any>response_);
                } catch (e) {
                    return <Observable<MasterSensorDetailData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterSensorDetailData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetailDataBySerialNumber(response: HttpResponseBase): Observable<MasterSensorDetailData[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterSensorDetailData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterSensorDetailData[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteDetailData(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/DeleteDetailData?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDetailData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDetailData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDetailData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteDuplicateDataRows(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/DeleteDuplicateDataRows";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDuplicateDataRows(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDuplicateDataRows(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDuplicateDataRows(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteBulkDetailData(body: SiteChannelDelete | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/DeleteBulkDetailData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkDetailData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkDetailData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteBulkDetailData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteBulkDetailDataWithTime(body: SiteChannelTimeDelete | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/DeleteBulkDetailDataWithTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkDetailDataWithTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkDetailDataWithTime(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteBulkDetailDataWithTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllSummaryData(): Observable<MasterSensorSummaryData[]> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/GetAllSummaryData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSummaryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSummaryData(<any>response_);
                } catch (e) {
                    return <Observable<MasterSensorSummaryData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterSensorSummaryData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSummaryData(response: HttpResponseBase): Observable<MasterSensorSummaryData[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterSensorSummaryData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterSensorSummaryData[]>(<any>null);
    }

    /**
     * @return Success
     */
    getNewSummaryData(): Observable<MasterSensorSummaryData[]> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/GetNewSummaryData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewSummaryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewSummaryData(<any>response_);
                } catch (e) {
                    return <Observable<MasterSensorSummaryData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterSensorSummaryData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetNewSummaryData(response: HttpResponseBase): Observable<MasterSensorSummaryData[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterSensorSummaryData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterSensorSummaryData[]>(<any>null);
    }

    /**
     * @param sn (optional) 
     * @return Success
     */
    getSummaryDataBySN(sn: string | undefined): Observable<MasterSensorSummaryData[]> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/GetSummaryDataBySN?";
        if (sn === null)
            throw new Error("The parameter 'sn' cannot be null.");
        else if (sn !== undefined)
            url_ += "sn=" + encodeURIComponent("" + sn) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummaryDataBySN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummaryDataBySN(<any>response_);
                } catch (e) {
                    return <Observable<MasterSensorSummaryData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterSensorSummaryData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSummaryDataBySN(response: HttpResponseBase): Observable<MasterSensorSummaryData[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterSensorSummaryData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterSensorSummaryData[]>(<any>null);
    }

    /**
     * @param sn (optional) 
     * @param dateStart (optional) 
     * @param dateStop (optional) 
     * @return Success
     */
    getSummaryDataBySNAndDate(sn: string | undefined, dateStart: moment.Moment | undefined, dateStop: moment.Moment | undefined): Observable<MasterSensorSummaryData[]> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/GetSummaryDataBySNAndDate?";
        if (sn === null)
            throw new Error("The parameter 'sn' cannot be null.");
        else if (sn !== undefined)
            url_ += "sn=" + encodeURIComponent("" + sn) + "&"; 
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "dateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toJSON() : "") + "&"; 
        if (dateStop === null)
            throw new Error("The parameter 'dateStop' cannot be null.");
        else if (dateStop !== undefined)
            url_ += "dateStop=" + encodeURIComponent(dateStop ? "" + dateStop.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummaryDataBySNAndDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummaryDataBySNAndDate(<any>response_);
                } catch (e) {
                    return <Observable<MasterSensorSummaryData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterSensorSummaryData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSummaryDataBySNAndDate(response: HttpResponseBase): Observable<MasterSensorSummaryData[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterSensorSummaryData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterSensorSummaryData[]>(<any>null);
    }

    /**
     * @param sn (optional) 
     * @return Success
     */
    getSummaryDataForSignalStrength(sn: string | undefined): Observable<MasterSensorSummaryData> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/GetSummaryDataForSignalStrength?";
        if (sn === null)
            throw new Error("The parameter 'sn' cannot be null.");
        else if (sn !== undefined)
            url_ += "sn=" + encodeURIComponent("" + sn) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummaryDataForSignalStrength(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummaryDataForSignalStrength(<any>response_);
                } catch (e) {
                    return <Observable<MasterSensorSummaryData>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterSensorSummaryData>><any>_observableThrow(response_);
        }));
    }

    protected processGetSummaryDataForSignalStrength(response: HttpResponseBase): Observable<MasterSensorSummaryData> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterSensorSummaryData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterSensorSummaryData>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    markSummaryDataAsRead(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/MarkSummaryDataAsRead?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkSummaryDataAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkSummaryDataAsRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkSummaryDataAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteSummaryData(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/DeleteSummaryData?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSummaryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSummaryData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteSummaryData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param sn (optional) 
     * @param dtLatest (optional) 
     * @return Success
     */
    getStreamData(sn: string | undefined, dtLatest: moment.Moment | undefined): Observable<MasterSensorDetailData[]> {
        let url_ = this.baseUrl + "/hostapi/MasterSensorData/GetStreamData?";
        if (sn === null)
            throw new Error("The parameter 'sn' cannot be null.");
        else if (sn !== undefined)
            url_ += "sn=" + encodeURIComponent("" + sn) + "&"; 
        if (dtLatest === null)
            throw new Error("The parameter 'dtLatest' cannot be null.");
        else if (dtLatest !== undefined)
            url_ += "dtLatest=" + encodeURIComponent(dtLatest ? "" + dtLatest.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStreamData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStreamData(<any>response_);
                } catch (e) {
                    return <Observable<MasterSensorDetailData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterSensorDetailData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetStreamData(response: HttpResponseBase): Observable<MasterSensorDetailData[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterSensorDetailData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterSensorDetailData[]>(<any>null);
    }
}

@Injectable()
export class ProcessingServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HOST_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantName(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/hostapi/ProcessingService/GetTenantName?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantName(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getEnecticsUserEmails(): Observable<string[]> {
        let url_ = this.baseUrl + "/hostapi/ProcessingService/GetEnecticsUserEmails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnecticsUserEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnecticsUserEmails(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEnecticsUserEmails(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }
}

export class AbpEdition implements IAbpEdition {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    displayName!: string | undefined;
    isDeleted!: boolean;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    name!: string | undefined;
    discriminator!: string | undefined;
    annualPrice!: number | undefined;
    expiringEditionId!: number | undefined;
    monthlyPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    abpFeatures!: AbpFeature[] | undefined;
    abpTenants!: AbpTenant[] | undefined;
    appSubscriptionPayments!: AppSubscriptionPayment[] | undefined;

    constructor(data?: IAbpEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.displayName = data["displayName"];
            this.isDeleted = data["isDeleted"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.name = data["name"];
            this.discriminator = data["discriminator"];
            this.annualPrice = data["annualPrice"];
            this.expiringEditionId = data["expiringEditionId"];
            this.monthlyPrice = data["monthlyPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.dailyPrice = data["dailyPrice"];
            this.weeklyPrice = data["weeklyPrice"];
            if (Array.isArray(data["abpFeatures"])) {
                this.abpFeatures = [] as any;
                for (let item of data["abpFeatures"])
                    this.abpFeatures!.push(AbpFeature.fromJS(item));
            }
            if (Array.isArray(data["abpTenants"])) {
                this.abpTenants = [] as any;
                for (let item of data["abpTenants"])
                    this.abpTenants!.push(AbpTenant.fromJS(item));
            }
            if (Array.isArray(data["appSubscriptionPayments"])) {
                this.appSubscriptionPayments = [] as any;
                for (let item of data["appSubscriptionPayments"])
                    this.appSubscriptionPayments!.push(AppSubscriptionPayment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AbpEdition {
        data = typeof data === 'object' ? data : {};
        let result = new AbpEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["displayName"] = this.displayName;
        data["isDeleted"] = this.isDeleted;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["name"] = this.name;
        data["discriminator"] = this.discriminator;
        data["annualPrice"] = this.annualPrice;
        data["expiringEditionId"] = this.expiringEditionId;
        data["monthlyPrice"] = this.monthlyPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        if (Array.isArray(this.abpFeatures)) {
            data["abpFeatures"] = [];
            for (let item of this.abpFeatures)
                data["abpFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.abpTenants)) {
            data["abpTenants"] = [];
            for (let item of this.abpTenants)
                data["abpTenants"].push(item.toJSON());
        }
        if (Array.isArray(this.appSubscriptionPayments)) {
            data["appSubscriptionPayments"] = [];
            for (let item of this.appSubscriptionPayments)
                data["appSubscriptionPayments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAbpEdition {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    displayName: string | undefined;
    isDeleted: boolean;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    name: string | undefined;
    discriminator: string | undefined;
    annualPrice: number | undefined;
    expiringEditionId: number | undefined;
    monthlyPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    abpFeatures: AbpFeature[] | undefined;
    abpTenants: AbpTenant[] | undefined;
    appSubscriptionPayments: AppSubscriptionPayment[] | undefined;
}

export class AbpFeature implements IAbpFeature {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    discriminator!: string | undefined;
    name!: string | undefined;
    value!: string | undefined;
    editionId!: number | undefined;
    tenantId!: number | undefined;
    edition!: AbpEdition;

    constructor(data?: IAbpFeature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.discriminator = data["discriminator"];
            this.name = data["name"];
            this.value = data["value"];
            this.editionId = data["editionId"];
            this.tenantId = data["tenantId"];
            this.edition = data["edition"] ? AbpEdition.fromJS(data["edition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AbpFeature {
        data = typeof data === 'object' ? data : {};
        let result = new AbpFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["discriminator"] = this.discriminator;
        data["name"] = this.name;
        data["value"] = this.value;
        data["editionId"] = this.editionId;
        data["tenantId"] = this.tenantId;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAbpFeature {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    discriminator: string | undefined;
    name: string | undefined;
    value: string | undefined;
    editionId: number | undefined;
    tenantId: number | undefined;
    edition: AbpEdition;
}

export class AbpPermission implements IAbpPermission {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    discriminator!: string | undefined;
    isGranted!: boolean;
    name!: string | undefined;
    tenantId!: number | undefined;
    roleId!: number | undefined;
    userId!: number | undefined;
    role!: AbpRole;
    user!: AbpUser;

    constructor(data?: IAbpPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.discriminator = data["discriminator"];
            this.isGranted = data["isGranted"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.roleId = data["roleId"];
            this.userId = data["userId"];
            this.role = data["role"] ? AbpRole.fromJS(data["role"]) : <any>undefined;
            this.user = data["user"] ? AbpUser.fromJS(data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AbpPermission {
        data = typeof data === 'object' ? data : {};
        let result = new AbpPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["discriminator"] = this.discriminator;
        data["isGranted"] = this.isGranted;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["roleId"] = this.roleId;
        data["userId"] = this.userId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAbpPermission {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    discriminator: string | undefined;
    isGranted: boolean;
    name: string | undefined;
    tenantId: number | undefined;
    roleId: number | undefined;
    userId: number | undefined;
    role: AbpRole;
    user: AbpUser;
}

export class AbpRole implements IAbpRole {
    id!: number;
    concurrencyStamp!: string | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    displayName!: string | undefined;
    isDefault!: boolean;
    isDeleted!: boolean;
    isStatic!: boolean;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    name!: string | undefined;
    normalizedName!: string | undefined;
    tenantId!: number | undefined;
    creatorUser!: AbpUser;
    deleterUser!: AbpUser;
    lastModifierUser!: AbpUser;
    abpPermissions!: AbpPermission[] | undefined;
    abpRoleClaims!: AbpRoleClaim[] | undefined;

    constructor(data?: IAbpRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.concurrencyStamp = data["concurrencyStamp"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.displayName = data["displayName"];
            this.isDefault = data["isDefault"];
            this.isDeleted = data["isDeleted"];
            this.isStatic = data["isStatic"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.name = data["name"];
            this.normalizedName = data["normalizedName"];
            this.tenantId = data["tenantId"];
            this.creatorUser = data["creatorUser"] ? AbpUser.fromJS(data["creatorUser"]) : <any>undefined;
            this.deleterUser = data["deleterUser"] ? AbpUser.fromJS(data["deleterUser"]) : <any>undefined;
            this.lastModifierUser = data["lastModifierUser"] ? AbpUser.fromJS(data["lastModifierUser"]) : <any>undefined;
            if (Array.isArray(data["abpPermissions"])) {
                this.abpPermissions = [] as any;
                for (let item of data["abpPermissions"])
                    this.abpPermissions!.push(AbpPermission.fromJS(item));
            }
            if (Array.isArray(data["abpRoleClaims"])) {
                this.abpRoleClaims = [] as any;
                for (let item of data["abpRoleClaims"])
                    this.abpRoleClaims!.push(AbpRoleClaim.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AbpRole {
        data = typeof data === 'object' ? data : {};
        let result = new AbpRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        data["isDeleted"] = this.isDeleted;
        data["isStatic"] = this.isStatic;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["tenantId"] = this.tenantId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        if (Array.isArray(this.abpPermissions)) {
            data["abpPermissions"] = [];
            for (let item of this.abpPermissions)
                data["abpPermissions"].push(item.toJSON());
        }
        if (Array.isArray(this.abpRoleClaims)) {
            data["abpRoleClaims"] = [];
            for (let item of this.abpRoleClaims)
                data["abpRoleClaims"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAbpRole {
    id: number;
    concurrencyStamp: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    displayName: string | undefined;
    isDefault: boolean;
    isDeleted: boolean;
    isStatic: boolean;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    name: string | undefined;
    normalizedName: string | undefined;
    tenantId: number | undefined;
    creatorUser: AbpUser;
    deleterUser: AbpUser;
    lastModifierUser: AbpUser;
    abpPermissions: AbpPermission[] | undefined;
    abpRoleClaims: AbpRoleClaim[] | undefined;
}

export class AbpRoleClaim implements IAbpRoleClaim {
    id!: number;
    claimType!: string | undefined;
    claimValue!: string | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    roleId!: number;
    tenantId!: number | undefined;
    role!: AbpRole;

    constructor(data?: IAbpRoleClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.claimType = data["claimType"];
            this.claimValue = data["claimValue"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.roleId = data["roleId"];
            this.tenantId = data["tenantId"];
            this.role = data["role"] ? AbpRole.fromJS(data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AbpRoleClaim {
        data = typeof data === 'object' ? data : {};
        let result = new AbpRoleClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["roleId"] = this.roleId;
        data["tenantId"] = this.tenantId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAbpRoleClaim {
    id: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    roleId: number;
    tenantId: number | undefined;
    role: AbpRole;
}

export class AbpSetting implements IAbpSetting {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    name!: string | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    value!: string | undefined;
    user!: AbpUser;

    constructor(data?: IAbpSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.value = data["value"];
            this.user = data["user"] ? AbpUser.fromJS(data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AbpSetting {
        data = typeof data === 'object' ? data : {};
        let result = new AbpSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["value"] = this.value;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAbpSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    name: string | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    value: string | undefined;
    user: AbpUser;
}

export class AbpTenant implements IAbpTenant {
    id!: number;
    connectionString!: string | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    customCssId!: string | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    editionId!: number | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    logoFileType!: string | undefined;
    logoId!: string | undefined;
    name!: string | undefined;
    tenancyName!: string | undefined;
    isInTrialPeriod!: boolean | undefined;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    subscriptionPaymentType!: number;
    address!: string | undefined;
    city!: string | undefined;
    country!: string | undefined;
    state!: string | undefined;
    zipcode!: string | undefined;
    creatorUser!: AbpUser;
    deleterUser!: AbpUser;
    edition!: AbpEdition;
    lastModifierUser!: AbpUser;
    masterFormulaTenants!: MasterFormulaTenant[] | undefined;
    masterMeters!: MasterMeter[] | undefined;
    masterRtus!: MasterRtu[] | undefined;

    constructor(data?: IAbpTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.connectionString = data["connectionString"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.customCssId = data["customCssId"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.logoFileType = data["logoFileType"];
            this.logoId = data["logoId"];
            this.name = data["name"];
            this.tenancyName = data["tenancyName"];
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.subscriptionPaymentType = data["subscriptionPaymentType"];
            this.address = data["address"];
            this.city = data["city"];
            this.country = data["country"];
            this.state = data["state"];
            this.zipcode = data["zipcode"];
            this.creatorUser = data["creatorUser"] ? AbpUser.fromJS(data["creatorUser"]) : <any>undefined;
            this.deleterUser = data["deleterUser"] ? AbpUser.fromJS(data["deleterUser"]) : <any>undefined;
            this.edition = data["edition"] ? AbpEdition.fromJS(data["edition"]) : <any>undefined;
            this.lastModifierUser = data["lastModifierUser"] ? AbpUser.fromJS(data["lastModifierUser"]) : <any>undefined;
            if (Array.isArray(data["masterFormulaTenants"])) {
                this.masterFormulaTenants = [] as any;
                for (let item of data["masterFormulaTenants"])
                    this.masterFormulaTenants!.push(MasterFormulaTenant.fromJS(item));
            }
            if (Array.isArray(data["masterMeters"])) {
                this.masterMeters = [] as any;
                for (let item of data["masterMeters"])
                    this.masterMeters!.push(MasterMeter.fromJS(item));
            }
            if (Array.isArray(data["masterRtus"])) {
                this.masterRtus = [] as any;
                for (let item of data["masterRtus"])
                    this.masterRtus!.push(MasterRtu.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AbpTenant {
        data = typeof data === 'object' ? data : {};
        let result = new AbpTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["connectionString"] = this.connectionString;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["customCssId"] = this.customCssId;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["logoFileType"] = this.logoFileType;
        data["logoId"] = this.logoId;
        data["name"] = this.name;
        data["tenancyName"] = this.tenancyName;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["address"] = this.address;
        data["city"] = this.city;
        data["country"] = this.country;
        data["state"] = this.state;
        data["zipcode"] = this.zipcode;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        if (Array.isArray(this.masterFormulaTenants)) {
            data["masterFormulaTenants"] = [];
            for (let item of this.masterFormulaTenants)
                data["masterFormulaTenants"].push(item.toJSON());
        }
        if (Array.isArray(this.masterMeters)) {
            data["masterMeters"] = [];
            for (let item of this.masterMeters)
                data["masterMeters"].push(item.toJSON());
        }
        if (Array.isArray(this.masterRtus)) {
            data["masterRtus"] = [];
            for (let item of this.masterRtus)
                data["masterRtus"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAbpTenant {
    id: number;
    connectionString: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    customCssId: string | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    editionId: number | undefined;
    isActive: boolean;
    isDeleted: boolean;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    logoFileType: string | undefined;
    logoId: string | undefined;
    name: string | undefined;
    tenancyName: string | undefined;
    isInTrialPeriod: boolean | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    subscriptionPaymentType: number;
    address: string | undefined;
    city: string | undefined;
    country: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    creatorUser: AbpUser;
    deleterUser: AbpUser;
    edition: AbpEdition;
    lastModifierUser: AbpUser;
    masterFormulaTenants: MasterFormulaTenant[] | undefined;
    masterMeters: MasterMeter[] | undefined;
    masterRtus: MasterRtu[] | undefined;
}

export class AbpUser implements IAbpUser {
    id!: number;
    accessFailedCount!: number;
    authenticationSource!: string | undefined;
    concurrencyStamp!: string | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    emailAddress!: string | undefined;
    emailConfirmationCode!: string | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    isEmailConfirmed!: boolean;
    isLockoutEnabled!: boolean;
    isPhoneNumberConfirmed!: boolean;
    isTwoFactorEnabled!: boolean;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    lockoutEndDateUtc!: moment.Moment | undefined;
    name!: string | undefined;
    normalizedEmailAddress!: string | undefined;
    normalizedUserName!: string | undefined;
    password!: string | undefined;
    passwordResetCode!: string | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;
    securityStamp!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    surname!: string | undefined;
    tenantId!: number | undefined;
    userName!: string | undefined;
    signInToken!: string | undefined;
    signInTokenExpireTimeUtc!: moment.Moment | undefined;
    googleAuthenticatorKey!: string | undefined;
    passwordChangeDate!: moment.Moment | undefined;
    alertEmails!: string | undefined;
    dateFormat!: string | undefined;
    timeClock!: string | undefined;
    timeFormat!: string | undefined;
    siteMapLatitude!: number | undefined;
    siteMapLongitude!: number | undefined;
    siteMapZoom!: number | undefined;
    creatorUser!: AbpUser;
    deleterUser!: AbpUser;
    lastModifierUser!: AbpUser;
    abpPermissions!: AbpPermission[] | undefined;
    abpRoleCreatorUsers!: AbpRole[] | undefined;
    abpRoleDeleterUsers!: AbpRole[] | undefined;
    abpRoleLastModifierUsers!: AbpRole[] | undefined;
    abpSettings!: AbpSetting[] | undefined;
    abpTenantCreatorUsers!: AbpTenant[] | undefined;
    abpTenantDeleterUsers!: AbpTenant[] | undefined;
    abpTenantLastModifierUsers!: AbpTenant[] | undefined;
    abpUserClaims!: AbpUserClaim[] | undefined;
    abpUserLogins!: AbpUserLogin[] | undefined;
    abpUserOrganizationUnits!: AbpUserOrganizationUnit[] | undefined;
    abpUserRoles!: AbpUserRole[] | undefined;
    abpUserTokens!: AbpUserToken[] | undefined;
    groups!: Group[] | undefined;
    inverseCreatorUser!: AbpUser[] | undefined;
    inverseDeleterUser!: AbpUser[] | undefined;
    inverseLastModifierUser!: AbpUser[] | undefined;
    siteUsers!: SiteUser[] | undefined;
    userAdditionalPhones!: UserAdditionalPhone[] | undefined;
    userOldPasswords!: UserOldPassword[] | undefined;

    constructor(data?: IAbpUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.accessFailedCount = data["accessFailedCount"];
            this.authenticationSource = data["authenticationSource"];
            this.concurrencyStamp = data["concurrencyStamp"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.emailAddress = data["emailAddress"];
            this.emailConfirmationCode = data["emailConfirmationCode"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lockoutEndDateUtc = data["lockoutEndDateUtc"] ? moment(data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.name = data["name"];
            this.normalizedEmailAddress = data["normalizedEmailAddress"];
            this.normalizedUserName = data["normalizedUserName"];
            this.password = data["password"];
            this.passwordResetCode = data["passwordResetCode"];
            this.phoneNumber = data["phoneNumber"];
            this.profilePictureId = data["profilePictureId"];
            this.securityStamp = data["securityStamp"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.surname = data["surname"];
            this.tenantId = data["tenantId"];
            this.userName = data["userName"];
            this.signInToken = data["signInToken"];
            this.signInTokenExpireTimeUtc = data["signInTokenExpireTimeUtc"] ? moment(data["signInTokenExpireTimeUtc"].toString()) : <any>undefined;
            this.googleAuthenticatorKey = data["googleAuthenticatorKey"];
            this.passwordChangeDate = data["passwordChangeDate"] ? moment(data["passwordChangeDate"].toString()) : <any>undefined;
            this.alertEmails = data["alertEmails"];
            this.dateFormat = data["dateFormat"];
            this.timeClock = data["timeClock"];
            this.timeFormat = data["timeFormat"];
            this.siteMapLatitude = data["siteMapLatitude"];
            this.siteMapLongitude = data["siteMapLongitude"];
            this.siteMapZoom = data["siteMapZoom"];
            this.creatorUser = data["creatorUser"] ? AbpUser.fromJS(data["creatorUser"]) : <any>undefined;
            this.deleterUser = data["deleterUser"] ? AbpUser.fromJS(data["deleterUser"]) : <any>undefined;
            this.lastModifierUser = data["lastModifierUser"] ? AbpUser.fromJS(data["lastModifierUser"]) : <any>undefined;
            if (Array.isArray(data["abpPermissions"])) {
                this.abpPermissions = [] as any;
                for (let item of data["abpPermissions"])
                    this.abpPermissions!.push(AbpPermission.fromJS(item));
            }
            if (Array.isArray(data["abpRoleCreatorUsers"])) {
                this.abpRoleCreatorUsers = [] as any;
                for (let item of data["abpRoleCreatorUsers"])
                    this.abpRoleCreatorUsers!.push(AbpRole.fromJS(item));
            }
            if (Array.isArray(data["abpRoleDeleterUsers"])) {
                this.abpRoleDeleterUsers = [] as any;
                for (let item of data["abpRoleDeleterUsers"])
                    this.abpRoleDeleterUsers!.push(AbpRole.fromJS(item));
            }
            if (Array.isArray(data["abpRoleLastModifierUsers"])) {
                this.abpRoleLastModifierUsers = [] as any;
                for (let item of data["abpRoleLastModifierUsers"])
                    this.abpRoleLastModifierUsers!.push(AbpRole.fromJS(item));
            }
            if (Array.isArray(data["abpSettings"])) {
                this.abpSettings = [] as any;
                for (let item of data["abpSettings"])
                    this.abpSettings!.push(AbpSetting.fromJS(item));
            }
            if (Array.isArray(data["abpTenantCreatorUsers"])) {
                this.abpTenantCreatorUsers = [] as any;
                for (let item of data["abpTenantCreatorUsers"])
                    this.abpTenantCreatorUsers!.push(AbpTenant.fromJS(item));
            }
            if (Array.isArray(data["abpTenantDeleterUsers"])) {
                this.abpTenantDeleterUsers = [] as any;
                for (let item of data["abpTenantDeleterUsers"])
                    this.abpTenantDeleterUsers!.push(AbpTenant.fromJS(item));
            }
            if (Array.isArray(data["abpTenantLastModifierUsers"])) {
                this.abpTenantLastModifierUsers = [] as any;
                for (let item of data["abpTenantLastModifierUsers"])
                    this.abpTenantLastModifierUsers!.push(AbpTenant.fromJS(item));
            }
            if (Array.isArray(data["abpUserClaims"])) {
                this.abpUserClaims = [] as any;
                for (let item of data["abpUserClaims"])
                    this.abpUserClaims!.push(AbpUserClaim.fromJS(item));
            }
            if (Array.isArray(data["abpUserLogins"])) {
                this.abpUserLogins = [] as any;
                for (let item of data["abpUserLogins"])
                    this.abpUserLogins!.push(AbpUserLogin.fromJS(item));
            }
            if (Array.isArray(data["abpUserOrganizationUnits"])) {
                this.abpUserOrganizationUnits = [] as any;
                for (let item of data["abpUserOrganizationUnits"])
                    this.abpUserOrganizationUnits!.push(AbpUserOrganizationUnit.fromJS(item));
            }
            if (Array.isArray(data["abpUserRoles"])) {
                this.abpUserRoles = [] as any;
                for (let item of data["abpUserRoles"])
                    this.abpUserRoles!.push(AbpUserRole.fromJS(item));
            }
            if (Array.isArray(data["abpUserTokens"])) {
                this.abpUserTokens = [] as any;
                for (let item of data["abpUserTokens"])
                    this.abpUserTokens!.push(AbpUserToken.fromJS(item));
            }
            if (Array.isArray(data["groups"])) {
                this.groups = [] as any;
                for (let item of data["groups"])
                    this.groups!.push(Group.fromJS(item));
            }
            if (Array.isArray(data["inverseCreatorUser"])) {
                this.inverseCreatorUser = [] as any;
                for (let item of data["inverseCreatorUser"])
                    this.inverseCreatorUser!.push(AbpUser.fromJS(item));
            }
            if (Array.isArray(data["inverseDeleterUser"])) {
                this.inverseDeleterUser = [] as any;
                for (let item of data["inverseDeleterUser"])
                    this.inverseDeleterUser!.push(AbpUser.fromJS(item));
            }
            if (Array.isArray(data["inverseLastModifierUser"])) {
                this.inverseLastModifierUser = [] as any;
                for (let item of data["inverseLastModifierUser"])
                    this.inverseLastModifierUser!.push(AbpUser.fromJS(item));
            }
            if (Array.isArray(data["siteUsers"])) {
                this.siteUsers = [] as any;
                for (let item of data["siteUsers"])
                    this.siteUsers!.push(SiteUser.fromJS(item));
            }
            if (Array.isArray(data["userAdditionalPhones"])) {
                this.userAdditionalPhones = [] as any;
                for (let item of data["userAdditionalPhones"])
                    this.userAdditionalPhones!.push(UserAdditionalPhone.fromJS(item));
            }
            if (Array.isArray(data["userOldPasswords"])) {
                this.userOldPasswords = [] as any;
                for (let item of data["userOldPasswords"])
                    this.userOldPasswords!.push(UserOldPassword.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AbpUser {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accessFailedCount"] = this.accessFailedCount;
        data["authenticationSource"] = this.authenticationSource;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["normalizedUserName"] = this.normalizedUserName;
        data["password"] = this.password;
        data["passwordResetCode"] = this.passwordResetCode;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["securityStamp"] = this.securityStamp;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["surname"] = this.surname;
        data["tenantId"] = this.tenantId;
        data["userName"] = this.userName;
        data["signInToken"] = this.signInToken;
        data["signInTokenExpireTimeUtc"] = this.signInTokenExpireTimeUtc ? this.signInTokenExpireTimeUtc.toISOString() : <any>undefined;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        data["passwordChangeDate"] = this.passwordChangeDate ? this.passwordChangeDate.toISOString() : <any>undefined;
        data["alertEmails"] = this.alertEmails;
        data["dateFormat"] = this.dateFormat;
        data["timeClock"] = this.timeClock;
        data["timeFormat"] = this.timeFormat;
        data["siteMapLatitude"] = this.siteMapLatitude;
        data["siteMapLongitude"] = this.siteMapLongitude;
        data["siteMapZoom"] = this.siteMapZoom;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        if (Array.isArray(this.abpPermissions)) {
            data["abpPermissions"] = [];
            for (let item of this.abpPermissions)
                data["abpPermissions"].push(item.toJSON());
        }
        if (Array.isArray(this.abpRoleCreatorUsers)) {
            data["abpRoleCreatorUsers"] = [];
            for (let item of this.abpRoleCreatorUsers)
                data["abpRoleCreatorUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.abpRoleDeleterUsers)) {
            data["abpRoleDeleterUsers"] = [];
            for (let item of this.abpRoleDeleterUsers)
                data["abpRoleDeleterUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.abpRoleLastModifierUsers)) {
            data["abpRoleLastModifierUsers"] = [];
            for (let item of this.abpRoleLastModifierUsers)
                data["abpRoleLastModifierUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.abpSettings)) {
            data["abpSettings"] = [];
            for (let item of this.abpSettings)
                data["abpSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.abpTenantCreatorUsers)) {
            data["abpTenantCreatorUsers"] = [];
            for (let item of this.abpTenantCreatorUsers)
                data["abpTenantCreatorUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.abpTenantDeleterUsers)) {
            data["abpTenantDeleterUsers"] = [];
            for (let item of this.abpTenantDeleterUsers)
                data["abpTenantDeleterUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.abpTenantLastModifierUsers)) {
            data["abpTenantLastModifierUsers"] = [];
            for (let item of this.abpTenantLastModifierUsers)
                data["abpTenantLastModifierUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.abpUserClaims)) {
            data["abpUserClaims"] = [];
            for (let item of this.abpUserClaims)
                data["abpUserClaims"].push(item.toJSON());
        }
        if (Array.isArray(this.abpUserLogins)) {
            data["abpUserLogins"] = [];
            for (let item of this.abpUserLogins)
                data["abpUserLogins"].push(item.toJSON());
        }
        if (Array.isArray(this.abpUserOrganizationUnits)) {
            data["abpUserOrganizationUnits"] = [];
            for (let item of this.abpUserOrganizationUnits)
                data["abpUserOrganizationUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.abpUserRoles)) {
            data["abpUserRoles"] = [];
            for (let item of this.abpUserRoles)
                data["abpUserRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.abpUserTokens)) {
            data["abpUserTokens"] = [];
            for (let item of this.abpUserTokens)
                data["abpUserTokens"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.inverseCreatorUser)) {
            data["inverseCreatorUser"] = [];
            for (let item of this.inverseCreatorUser)
                data["inverseCreatorUser"].push(item.toJSON());
        }
        if (Array.isArray(this.inverseDeleterUser)) {
            data["inverseDeleterUser"] = [];
            for (let item of this.inverseDeleterUser)
                data["inverseDeleterUser"].push(item.toJSON());
        }
        if (Array.isArray(this.inverseLastModifierUser)) {
            data["inverseLastModifierUser"] = [];
            for (let item of this.inverseLastModifierUser)
                data["inverseLastModifierUser"].push(item.toJSON());
        }
        if (Array.isArray(this.siteUsers)) {
            data["siteUsers"] = [];
            for (let item of this.siteUsers)
                data["siteUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.userAdditionalPhones)) {
            data["userAdditionalPhones"] = [];
            for (let item of this.userAdditionalPhones)
                data["userAdditionalPhones"].push(item.toJSON());
        }
        if (Array.isArray(this.userOldPasswords)) {
            data["userOldPasswords"] = [];
            for (let item of this.userOldPasswords)
                data["userOldPasswords"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAbpUser {
    id: number;
    accessFailedCount: number;
    authenticationSource: string | undefined;
    concurrencyStamp: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    emailAddress: string | undefined;
    emailConfirmationCode: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    isEmailConfirmed: boolean;
    isLockoutEnabled: boolean;
    isPhoneNumberConfirmed: boolean;
    isTwoFactorEnabled: boolean;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    name: string | undefined;
    normalizedEmailAddress: string | undefined;
    normalizedUserName: string | undefined;
    password: string | undefined;
    passwordResetCode: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    securityStamp: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    surname: string | undefined;
    tenantId: number | undefined;
    userName: string | undefined;
    signInToken: string | undefined;
    signInTokenExpireTimeUtc: moment.Moment | undefined;
    googleAuthenticatorKey: string | undefined;
    passwordChangeDate: moment.Moment | undefined;
    alertEmails: string | undefined;
    dateFormat: string | undefined;
    timeClock: string | undefined;
    timeFormat: string | undefined;
    siteMapLatitude: number | undefined;
    siteMapLongitude: number | undefined;
    siteMapZoom: number | undefined;
    creatorUser: AbpUser;
    deleterUser: AbpUser;
    lastModifierUser: AbpUser;
    abpPermissions: AbpPermission[] | undefined;
    abpRoleCreatorUsers: AbpRole[] | undefined;
    abpRoleDeleterUsers: AbpRole[] | undefined;
    abpRoleLastModifierUsers: AbpRole[] | undefined;
    abpSettings: AbpSetting[] | undefined;
    abpTenantCreatorUsers: AbpTenant[] | undefined;
    abpTenantDeleterUsers: AbpTenant[] | undefined;
    abpTenantLastModifierUsers: AbpTenant[] | undefined;
    abpUserClaims: AbpUserClaim[] | undefined;
    abpUserLogins: AbpUserLogin[] | undefined;
    abpUserOrganizationUnits: AbpUserOrganizationUnit[] | undefined;
    abpUserRoles: AbpUserRole[] | undefined;
    abpUserTokens: AbpUserToken[] | undefined;
    groups: Group[] | undefined;
    inverseCreatorUser: AbpUser[] | undefined;
    inverseDeleterUser: AbpUser[] | undefined;
    inverseLastModifierUser: AbpUser[] | undefined;
    siteUsers: SiteUser[] | undefined;
    userAdditionalPhones: UserAdditionalPhone[] | undefined;
    userOldPasswords: UserOldPassword[] | undefined;
}

export class AbpUserClaim implements IAbpUserClaim {
    id!: number;
    claimType!: string | undefined;
    claimValue!: string | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number;
    user!: AbpUser;

    constructor(data?: IAbpUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.claimType = data["claimType"];
            this.claimValue = data["claimValue"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.user = data["user"] ? AbpUser.fromJS(data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AbpUserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAbpUserClaim {
    id: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    user: AbpUser;
}

export class AbpUserLogin implements IAbpUserLogin {
    id!: number;
    loginProvider!: string | undefined;
    providerKey!: string | undefined;
    tenantId!: number | undefined;
    userId!: number;
    user!: AbpUser;

    constructor(data?: IAbpUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.loginProvider = data["loginProvider"];
            this.providerKey = data["providerKey"];
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.user = data["user"] ? AbpUser.fromJS(data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AbpUserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAbpUserLogin {
    id: number;
    loginProvider: string | undefined;
    providerKey: string | undefined;
    tenantId: number | undefined;
    userId: number;
    user: AbpUser;
}

export class AbpUserOrganizationUnit implements IAbpUserOrganizationUnit {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    organizationUnitId!: number;
    tenantId!: number | undefined;
    userId!: number;
    isDeleted!: boolean | undefined;
    user!: AbpUser;

    constructor(data?: IAbpUserOrganizationUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.organizationUnitId = data["organizationUnitId"];
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.isDeleted = data["isDeleted"];
            this.user = data["user"] ? AbpUser.fromJS(data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AbpUserOrganizationUnit {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserOrganizationUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["organizationUnitId"] = this.organizationUnitId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["isDeleted"] = this.isDeleted;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAbpUserOrganizationUnit {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    organizationUnitId: number;
    tenantId: number | undefined;
    userId: number;
    isDeleted: boolean | undefined;
    user: AbpUser;
}

export class AbpUserRole implements IAbpUserRole {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    roleId!: number;
    tenantId!: number | undefined;
    userId!: number;
    user!: AbpUser;

    constructor(data?: IAbpUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.roleId = data["roleId"];
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.user = data["user"] ? AbpUser.fromJS(data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AbpUserRole {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["roleId"] = this.roleId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAbpUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    roleId: number;
    tenantId: number | undefined;
    userId: number;
    user: AbpUser;
}

export class AbpUserToken implements IAbpUserToken {
    id!: number;
    loginProvider!: string | undefined;
    name!: string | undefined;
    tenantId!: number | undefined;
    userId!: number;
    value!: string | undefined;
    expireDate!: moment.Moment | undefined;
    user!: AbpUser;

    constructor(data?: IAbpUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.loginProvider = data["loginProvider"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.value = data["value"];
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.user = data["user"] ? AbpUser.fromJS(data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AbpUserToken {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAbpUserToken {
    id: number;
    loginProvider: string | undefined;
    name: string | undefined;
    tenantId: number | undefined;
    userId: number;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    user: AbpUser;
}

export class AppBinaryObject implements IAppBinaryObject {
    id!: string;
    bytes!: string | undefined;
    tenantId!: number | undefined;

    constructor(data?: IAppBinaryObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.bytes = data["bytes"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): AppBinaryObject {
        data = typeof data === 'object' ? data : {};
        let result = new AppBinaryObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bytes"] = this.bytes;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IAppBinaryObject {
    id: string;
    bytes: string | undefined;
    tenantId: number | undefined;
}

export class AppSubscriptionPayment implements IAppSubscriptionPayment {
    id!: number;
    amount!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    dayCount!: number;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    editionId!: number;
    gateway!: number;
    isDeleted!: boolean;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    successUrl!: string | undefined;
    paymentPeriodType!: number | undefined;
    status!: number;
    tenantId!: number;
    invoiceNo!: string | undefined;
    description!: string | undefined;
    errorUrl!: string | undefined;
    externalPaymentId!: string | undefined;
    isRecurring!: boolean | undefined;
    editionPaymentType!: number;
    edition!: AbpEdition;

    constructor(data?: IAppSubscriptionPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.amount = data["amount"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.dayCount = data["dayCount"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.editionId = data["editionId"];
            this.gateway = data["gateway"];
            this.isDeleted = data["isDeleted"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.successUrl = data["successUrl"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.invoiceNo = data["invoiceNo"];
            this.description = data["description"];
            this.errorUrl = data["errorUrl"];
            this.externalPaymentId = data["externalPaymentId"];
            this.isRecurring = data["isRecurring"];
            this.editionPaymentType = data["editionPaymentType"];
            this.edition = data["edition"] ? AbpEdition.fromJS(data["edition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppSubscriptionPayment {
        data = typeof data === 'object' ? data : {};
        let result = new AppSubscriptionPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["dayCount"] = this.dayCount;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["gateway"] = this.gateway;
        data["isDeleted"] = this.isDeleted;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["successUrl"] = this.successUrl;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["description"] = this.description;
        data["errorUrl"] = this.errorUrl;
        data["externalPaymentId"] = this.externalPaymentId;
        data["isRecurring"] = this.isRecurring;
        data["editionPaymentType"] = this.editionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAppSubscriptionPayment {
    id: number;
    amount: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    dayCount: number;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    editionId: number;
    gateway: number;
    isDeleted: boolean;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    successUrl: string | undefined;
    paymentPeriodType: number | undefined;
    status: number;
    tenantId: number;
    invoiceNo: string | undefined;
    description: string | undefined;
    errorUrl: string | undefined;
    externalPaymentId: string | undefined;
    isRecurring: boolean | undefined;
    editionPaymentType: number;
    edition: AbpEdition;
}

export class GetFormulasForDropDownOutput implements IGetFormulasForDropDownOutput {
    formulaId!: number;
    formulaName!: string | undefined;

    constructor(data?: IGetFormulasForDropDownOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formulaId = data["formulaId"];
            this.formulaName = data["formulaName"];
        }
    }

    static fromJS(data: any): GetFormulasForDropDownOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormulasForDropDownOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formulaId"] = this.formulaId;
        data["formulaName"] = this.formulaName;
        return data; 
    }
}

export interface IGetFormulasForDropDownOutput {
    formulaId: number;
    formulaName: string | undefined;
}

export class Group implements IGroup {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    tenantId!: number;
    groupName!: string | undefined;
    groupOwnerId!: number;
    groupOwner!: AbpUser;
    groupSites!: GroupSite[] | undefined;

    constructor(data?: IGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.tenantId = data["tenantId"];
            this.groupName = data["groupName"];
            this.groupOwnerId = data["groupOwnerId"];
            this.groupOwner = data["groupOwner"] ? AbpUser.fromJS(data["groupOwner"]) : <any>undefined;
            if (Array.isArray(data["groupSites"])) {
                this.groupSites = [] as any;
                for (let item of data["groupSites"])
                    this.groupSites!.push(GroupSite.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Group {
        data = typeof data === 'object' ? data : {};
        let result = new Group();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["groupName"] = this.groupName;
        data["groupOwnerId"] = this.groupOwnerId;
        data["groupOwner"] = this.groupOwner ? this.groupOwner.toJSON() : <any>undefined;
        if (Array.isArray(this.groupSites)) {
            data["groupSites"] = [];
            for (let item of this.groupSites)
                data["groupSites"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGroup {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number;
    groupName: string | undefined;
    groupOwnerId: number;
    groupOwner: AbpUser;
    groupSites: GroupSite[] | undefined;
}

export class GroupSite implements IGroupSite {
    groupId!: number;
    siteId!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    group!: Group;
    site!: Site;

    constructor(data?: IGroupSite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.groupId = data["groupId"];
            this.siteId = data["siteId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.group = data["group"] ? Group.fromJS(data["group"]) : <any>undefined;
            this.site = data["site"] ? Site.fromJS(data["site"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GroupSite {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["siteId"] = this.siteId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["site"] = this.site ? this.site.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGroupSite {
    groupId: number;
    siteId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    group: Group;
    site: Site;
}

export class LoginModel implements ILoginModel {
    username!: string;
    password!: string;

    constructor(data?: ILoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.username = data["username"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILoginModel {
    username: string;
    password: string;
}

export class MasterAuditLog implements IMasterAuditLog {
    id!: number;
    creationTime!: moment.Moment;
    auditType!: number;
    username!: string | undefined;
    affectedObject!: string | undefined;
    prevValue!: string | undefined;
    newValue!: string | undefined;
    ipAddress!: string | undefined;
    success!: boolean | undefined;
    callReason!: string | undefined;
    rtuSerialNumber!: number | undefined;
    siteName!: string | undefined;
    callStopTime!: moment.Moment | undefined;
    emails!: string | undefined;
    phoneNumbers!: string | undefined;
    alarmContent!: string | undefined;
    failureMessage!: string | undefined;
    tenantId!: number | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;

    constructor(data?: IMasterAuditLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.auditType = data["auditType"];
            this.username = data["username"];
            this.affectedObject = data["affectedObject"];
            this.prevValue = data["prevValue"];
            this.newValue = data["newValue"];
            this.ipAddress = data["ipAddress"];
            this.success = data["success"];
            this.callReason = data["callReason"];
            this.rtuSerialNumber = data["rtuSerialNumber"];
            this.siteName = data["siteName"];
            this.callStopTime = data["callStopTime"] ? moment(data["callStopTime"].toString()) : <any>undefined;
            this.emails = data["emails"];
            this.phoneNumbers = data["phoneNumbers"];
            this.alarmContent = data["alarmContent"];
            this.failureMessage = data["failureMessage"];
            this.tenantId = data["tenantId"];
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
        }
    }

    static fromJS(data: any): MasterAuditLog {
        data = typeof data === 'object' ? data : {};
        let result = new MasterAuditLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["auditType"] = this.auditType;
        data["username"] = this.username;
        data["affectedObject"] = this.affectedObject;
        data["prevValue"] = this.prevValue;
        data["newValue"] = this.newValue;
        data["ipAddress"] = this.ipAddress;
        data["success"] = this.success;
        data["callReason"] = this.callReason;
        data["rtuSerialNumber"] = this.rtuSerialNumber;
        data["siteName"] = this.siteName;
        data["callStopTime"] = this.callStopTime ? this.callStopTime.toISOString() : <any>undefined;
        data["emails"] = this.emails;
        data["phoneNumbers"] = this.phoneNumbers;
        data["alarmContent"] = this.alarmContent;
        data["failureMessage"] = this.failureMessage;
        data["tenantId"] = this.tenantId;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        return data; 
    }
}

export interface IMasterAuditLog {
    id: number;
    creationTime: moment.Moment;
    auditType: number;
    username: string | undefined;
    affectedObject: string | undefined;
    prevValue: string | undefined;
    newValue: string | undefined;
    ipAddress: string | undefined;
    success: boolean | undefined;
    callReason: string | undefined;
    rtuSerialNumber: number | undefined;
    siteName: string | undefined;
    callStopTime: moment.Moment | undefined;
    emails: string | undefined;
    phoneNumbers: string | undefined;
    alarmContent: string | undefined;
    failureMessage: string | undefined;
    tenantId: number | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
}

export class MasterDevice implements IMasterDevice {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    deviceType!: string | undefined;
    productType!: string | undefined;
    hardwareRevision!: string | undefined;
    isActive!: boolean;
    numberOfSensors!: number;
    masterDeviceFirmwares!: MasterDeviceFirmware[] | undefined;
    masterMeters!: MasterMeter[] | undefined;
    masterRtus!: MasterRtu[] | undefined;

    constructor(data?: IMasterDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.deviceType = data["deviceType"];
            this.productType = data["productType"];
            this.hardwareRevision = data["hardwareRevision"];
            this.isActive = data["isActive"];
            this.numberOfSensors = data["numberOfSensors"];
            if (Array.isArray(data["masterDeviceFirmwares"])) {
                this.masterDeviceFirmwares = [] as any;
                for (let item of data["masterDeviceFirmwares"])
                    this.masterDeviceFirmwares!.push(MasterDeviceFirmware.fromJS(item));
            }
            if (Array.isArray(data["masterMeters"])) {
                this.masterMeters = [] as any;
                for (let item of data["masterMeters"])
                    this.masterMeters!.push(MasterMeter.fromJS(item));
            }
            if (Array.isArray(data["masterRtus"])) {
                this.masterRtus = [] as any;
                for (let item of data["masterRtus"])
                    this.masterRtus!.push(MasterRtu.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MasterDevice {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["deviceType"] = this.deviceType;
        data["productType"] = this.productType;
        data["hardwareRevision"] = this.hardwareRevision;
        data["isActive"] = this.isActive;
        data["numberOfSensors"] = this.numberOfSensors;
        if (Array.isArray(this.masterDeviceFirmwares)) {
            data["masterDeviceFirmwares"] = [];
            for (let item of this.masterDeviceFirmwares)
                data["masterDeviceFirmwares"].push(item.toJSON());
        }
        if (Array.isArray(this.masterMeters)) {
            data["masterMeters"] = [];
            for (let item of this.masterMeters)
                data["masterMeters"].push(item.toJSON());
        }
        if (Array.isArray(this.masterRtus)) {
            data["masterRtus"] = [];
            for (let item of this.masterRtus)
                data["masterRtus"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMasterDevice {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    deviceType: string | undefined;
    productType: string | undefined;
    hardwareRevision: string | undefined;
    isActive: boolean;
    numberOfSensors: number;
    masterDeviceFirmwares: MasterDeviceFirmware[] | undefined;
    masterMeters: MasterMeter[] | undefined;
    masterRtus: MasterRtu[] | undefined;
}

export class MasterDeviceAuthenticationCodes implements IMasterDeviceAuthenticationCodes {
    id!: number;
    rtuSerialNumber!: string | undefined;
    authenticationActive!: boolean;
    authenticationCode!: string | undefined;

    constructor(data?: IMasterDeviceAuthenticationCodes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.rtuSerialNumber = data["rtuSerialNumber"];
            this.authenticationActive = data["authenticationActive"];
            this.authenticationCode = data["authenticationCode"];
        }
    }

    static fromJS(data: any): MasterDeviceAuthenticationCodes {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDeviceAuthenticationCodes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rtuSerialNumber"] = this.rtuSerialNumber;
        data["authenticationActive"] = this.authenticationActive;
        data["authenticationCode"] = this.authenticationCode;
        return data; 
    }
}

export interface IMasterDeviceAuthenticationCodes {
    id: number;
    rtuSerialNumber: string | undefined;
    authenticationActive: boolean;
    authenticationCode: string | undefined;
}

export class MasterDeviceBinaryMeasurementConfig implements IMasterDeviceBinaryMeasurementConfig {
    id!: number;
    masterDeviceConfiguration_ChannelId!: number;
    measurementType!: number;
    enabled!: boolean;
    alarmPolarity!: boolean;

    constructor(data?: IMasterDeviceBinaryMeasurementConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.masterDeviceConfiguration_ChannelId = data["masterDeviceConfiguration_ChannelId"];
            this.measurementType = data["measurementType"];
            this.enabled = data["enabled"];
            this.alarmPolarity = data["alarmPolarity"];
        }
    }

    static fromJS(data: any): MasterDeviceBinaryMeasurementConfig {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDeviceBinaryMeasurementConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["masterDeviceConfiguration_ChannelId"] = this.masterDeviceConfiguration_ChannelId;
        data["measurementType"] = this.measurementType;
        data["enabled"] = this.enabled;
        data["alarmPolarity"] = this.alarmPolarity;
        return data; 
    }
}

export interface IMasterDeviceBinaryMeasurementConfig {
    id: number;
    masterDeviceConfiguration_ChannelId: number;
    measurementType: number;
    enabled: boolean;
    alarmPolarity: boolean;
}

export class MasterDeviceConfiguration implements IMasterDeviceConfiguration {
    id!: number;
    rtuserialNumber!: string | undefined;
    callInFrequency!: number | undefined;
    sampleRate!: number | undefined;
    gasDensity!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    alarmSampleRate!: number | undefined;
    alarmCallInFrequency!: number | undefined;
    alarmMeasurementConfirmationSamples!: number | undefined;
    alarmSlamShutConfirmationSamples!: number | undefined;
    masterDeviceConfigurationChannels!: MasterDeviceConfigurationChannel[] | undefined;

    constructor(data?: IMasterDeviceConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.rtuserialNumber = data["rtuserialNumber"];
            this.callInFrequency = data["callInFrequency"];
            this.sampleRate = data["sampleRate"];
            this.gasDensity = data["gasDensity"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.alarmSampleRate = data["alarmSampleRate"];
            this.alarmCallInFrequency = data["alarmCallInFrequency"];
            this.alarmMeasurementConfirmationSamples = data["alarmMeasurementConfirmationSamples"];
            this.alarmSlamShutConfirmationSamples = data["alarmSlamShutConfirmationSamples"];
            if (Array.isArray(data["masterDeviceConfigurationChannels"])) {
                this.masterDeviceConfigurationChannels = [] as any;
                for (let item of data["masterDeviceConfigurationChannels"])
                    this.masterDeviceConfigurationChannels!.push(MasterDeviceConfigurationChannel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MasterDeviceConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDeviceConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rtuserialNumber"] = this.rtuserialNumber;
        data["callInFrequency"] = this.callInFrequency;
        data["sampleRate"] = this.sampleRate;
        data["gasDensity"] = this.gasDensity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["alarmSampleRate"] = this.alarmSampleRate;
        data["alarmCallInFrequency"] = this.alarmCallInFrequency;
        data["alarmMeasurementConfirmationSamples"] = this.alarmMeasurementConfirmationSamples;
        data["alarmSlamShutConfirmationSamples"] = this.alarmSlamShutConfirmationSamples;
        if (Array.isArray(this.masterDeviceConfigurationChannels)) {
            data["masterDeviceConfigurationChannels"] = [];
            for (let item of this.masterDeviceConfigurationChannels)
                data["masterDeviceConfigurationChannels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMasterDeviceConfiguration {
    id: number;
    rtuserialNumber: string | undefined;
    callInFrequency: number | undefined;
    sampleRate: number | undefined;
    gasDensity: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    alarmSampleRate: number | undefined;
    alarmCallInFrequency: number | undefined;
    alarmMeasurementConfirmationSamples: number | undefined;
    alarmSlamShutConfirmationSamples: number | undefined;
    masterDeviceConfigurationChannels: MasterDeviceConfigurationChannel[] | undefined;
}

export class MasterDeviceConfigurationChannel implements IMasterDeviceConfigurationChannel {
    id!: number;
    channelNumber!: number;
    channelNickname!: string | undefined;
    channelPipeDiameter!: number | undefined;
    masterDeviceConfigurationId!: number | undefined;
    channelGasDensity!: number | undefined;
    channelSensorType!: string | undefined;
    masterDeviceConfiguration!: MasterDeviceConfiguration;
    masterDeviceConfigurationMeasurements!: MasterDeviceConfigurationMeasurement[] | undefined;

    constructor(data?: IMasterDeviceConfigurationChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.channelNumber = data["channelNumber"];
            this.channelNickname = data["channelNickname"];
            this.channelPipeDiameter = data["channelPipeDiameter"];
            this.masterDeviceConfigurationId = data["masterDeviceConfigurationId"];
            this.channelGasDensity = data["channelGasDensity"];
            this.channelSensorType = data["channelSensorType"];
            this.masterDeviceConfiguration = data["masterDeviceConfiguration"] ? MasterDeviceConfiguration.fromJS(data["masterDeviceConfiguration"]) : <any>undefined;
            if (Array.isArray(data["masterDeviceConfigurationMeasurements"])) {
                this.masterDeviceConfigurationMeasurements = [] as any;
                for (let item of data["masterDeviceConfigurationMeasurements"])
                    this.masterDeviceConfigurationMeasurements!.push(MasterDeviceConfigurationMeasurement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MasterDeviceConfigurationChannel {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDeviceConfigurationChannel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["channelNumber"] = this.channelNumber;
        data["channelNickname"] = this.channelNickname;
        data["channelPipeDiameter"] = this.channelPipeDiameter;
        data["masterDeviceConfigurationId"] = this.masterDeviceConfigurationId;
        data["channelGasDensity"] = this.channelGasDensity;
        data["channelSensorType"] = this.channelSensorType;
        data["masterDeviceConfiguration"] = this.masterDeviceConfiguration ? this.masterDeviceConfiguration.toJSON() : <any>undefined;
        if (Array.isArray(this.masterDeviceConfigurationMeasurements)) {
            data["masterDeviceConfigurationMeasurements"] = [];
            for (let item of this.masterDeviceConfigurationMeasurements)
                data["masterDeviceConfigurationMeasurements"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMasterDeviceConfigurationChannel {
    id: number;
    channelNumber: number;
    channelNickname: string | undefined;
    channelPipeDiameter: number | undefined;
    masterDeviceConfigurationId: number | undefined;
    channelGasDensity: number | undefined;
    channelSensorType: string | undefined;
    masterDeviceConfiguration: MasterDeviceConfiguration;
    masterDeviceConfigurationMeasurements: MasterDeviceConfigurationMeasurement[] | undefined;
}

export class MasterDeviceConfigurationMeasurement implements IMasterDeviceConfigurationMeasurement {
    id!: number;
    measurement!: string | undefined;
    enabled!: string | undefined;
    lowLowAlarm!: number | undefined;
    lowAlarm!: number | undefined;
    highAlarm!: number | undefined;
    highHighAlarm!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    masterDeviceConfiguration_ChannelId!: number;
    units!: number;
    masterDeviceConfigurationChannel!: MasterDeviceConfigurationChannel;

    constructor(data?: IMasterDeviceConfigurationMeasurement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.measurement = data["measurement"];
            this.enabled = data["enabled"];
            this.lowLowAlarm = data["lowLowAlarm"];
            this.lowAlarm = data["lowAlarm"];
            this.highAlarm = data["highAlarm"];
            this.highHighAlarm = data["highHighAlarm"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.masterDeviceConfiguration_ChannelId = data["masterDeviceConfiguration_ChannelId"];
            this.units = data["units"];
            this.masterDeviceConfigurationChannel = data["masterDeviceConfigurationChannel"] ? MasterDeviceConfigurationChannel.fromJS(data["masterDeviceConfigurationChannel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MasterDeviceConfigurationMeasurement {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDeviceConfigurationMeasurement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["measurement"] = this.measurement;
        data["enabled"] = this.enabled;
        data["lowLowAlarm"] = this.lowLowAlarm;
        data["lowAlarm"] = this.lowAlarm;
        data["highAlarm"] = this.highAlarm;
        data["highHighAlarm"] = this.highHighAlarm;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["masterDeviceConfiguration_ChannelId"] = this.masterDeviceConfiguration_ChannelId;
        data["units"] = this.units;
        data["masterDeviceConfigurationChannel"] = this.masterDeviceConfigurationChannel ? this.masterDeviceConfigurationChannel.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMasterDeviceConfigurationMeasurement {
    id: number;
    measurement: string | undefined;
    enabled: string | undefined;
    lowLowAlarm: number | undefined;
    lowAlarm: number | undefined;
    highAlarm: number | undefined;
    highHighAlarm: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    masterDeviceConfiguration_ChannelId: number;
    units: number;
    masterDeviceConfigurationChannel: MasterDeviceConfigurationChannel;
}

export class MasterDeviceFirmware implements IMasterDeviceFirmware {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    version!: string | undefined;
    isActive!: boolean;
    masterDeviceId!: number;
    firmwareFileId!: string | undefined;
    firmwareFileName!: string | undefined;
    masterDevice!: MasterDevice;

    constructor(data?: IMasterDeviceFirmware) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.version = data["version"];
            this.isActive = data["isActive"];
            this.masterDeviceId = data["masterDeviceId"];
            this.firmwareFileId = data["firmwareFileId"];
            this.firmwareFileName = data["firmwareFileName"];
            this.masterDevice = data["masterDevice"] ? MasterDevice.fromJS(data["masterDevice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MasterDeviceFirmware {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDeviceFirmware();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["version"] = this.version;
        data["isActive"] = this.isActive;
        data["masterDeviceId"] = this.masterDeviceId;
        data["firmwareFileId"] = this.firmwareFileId;
        data["firmwareFileName"] = this.firmwareFileName;
        data["masterDevice"] = this.masterDevice ? this.masterDevice.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMasterDeviceFirmware {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    version: string | undefined;
    isActive: boolean;
    masterDeviceId: number;
    firmwareFileId: string | undefined;
    firmwareFileName: string | undefined;
    masterDevice: MasterDevice;
}

export class MasterFormula implements IMasterFormula {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    formulaName!: string | undefined;
    calculation!: string | undefined;
    unit!: string | undefined;
    measurement!: string | undefined;
    isActive!: boolean;
    masterFormulaTenants!: MasterFormulaTenant[] | undefined;

    constructor(data?: IMasterFormula) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.formulaName = data["formulaName"];
            this.calculation = data["calculation"];
            this.unit = data["unit"];
            this.measurement = data["measurement"];
            this.isActive = data["isActive"];
            if (Array.isArray(data["masterFormulaTenants"])) {
                this.masterFormulaTenants = [] as any;
                for (let item of data["masterFormulaTenants"])
                    this.masterFormulaTenants!.push(MasterFormulaTenant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MasterFormula {
        data = typeof data === 'object' ? data : {};
        let result = new MasterFormula();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["formulaName"] = this.formulaName;
        data["calculation"] = this.calculation;
        data["unit"] = this.unit;
        data["measurement"] = this.measurement;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.masterFormulaTenants)) {
            data["masterFormulaTenants"] = [];
            for (let item of this.masterFormulaTenants)
                data["masterFormulaTenants"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMasterFormula {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    formulaName: string | undefined;
    calculation: string | undefined;
    unit: string | undefined;
    measurement: string | undefined;
    isActive: boolean;
    masterFormulaTenants: MasterFormulaTenant[] | undefined;
}

export class MasterFormulaTenant implements IMasterFormulaTenant {
    masterFormulaId!: number;
    tenantId!: number;
    masterFormula!: MasterFormula;
    tenant!: AbpTenant;

    constructor(data?: IMasterFormulaTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.masterFormulaId = data["masterFormulaId"];
            this.tenantId = data["tenantId"];
            this.masterFormula = data["masterFormula"] ? MasterFormula.fromJS(data["masterFormula"]) : <any>undefined;
            this.tenant = data["tenant"] ? AbpTenant.fromJS(data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MasterFormulaTenant {
        data = typeof data === 'object' ? data : {};
        let result = new MasterFormulaTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterFormulaId"] = this.masterFormulaId;
        data["tenantId"] = this.tenantId;
        data["masterFormula"] = this.masterFormula ? this.masterFormula.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMasterFormulaTenant {
    masterFormulaId: number;
    tenantId: number;
    masterFormula: MasterFormula;
    tenant: AbpTenant;
}

export class MasterMeter implements IMasterMeter {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    tenantId!: number;
    meterSerialNumber!: string | undefined;
    calibrationLowValue!: number | undefined;
    calibrationHighValue!: number | undefined;
    sensorRange!: number | undefined;
    isActive!: boolean;
    masterDeviceId!: number;
    shippedDate!: moment.Moment;
    masterDevice!: MasterDevice;
    tenant!: AbpTenant;

    constructor(data?: IMasterMeter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.tenantId = data["tenantId"];
            this.meterSerialNumber = data["meterSerialNumber"];
            this.calibrationLowValue = data["calibrationLowValue"];
            this.calibrationHighValue = data["calibrationHighValue"];
            this.sensorRange = data["sensorRange"];
            this.isActive = data["isActive"];
            this.masterDeviceId = data["masterDeviceId"];
            this.shippedDate = data["shippedDate"] ? moment(data["shippedDate"].toString()) : <any>undefined;
            this.masterDevice = data["masterDevice"] ? MasterDevice.fromJS(data["masterDevice"]) : <any>undefined;
            this.tenant = data["tenant"] ? AbpTenant.fromJS(data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MasterMeter {
        data = typeof data === 'object' ? data : {};
        let result = new MasterMeter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["meterSerialNumber"] = this.meterSerialNumber;
        data["calibrationLowValue"] = this.calibrationLowValue;
        data["calibrationHighValue"] = this.calibrationHighValue;
        data["sensorRange"] = this.sensorRange;
        data["isActive"] = this.isActive;
        data["masterDeviceId"] = this.masterDeviceId;
        data["shippedDate"] = this.shippedDate ? this.shippedDate.toISOString() : <any>undefined;
        data["masterDevice"] = this.masterDevice ? this.masterDevice.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMasterMeter {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number;
    meterSerialNumber: string | undefined;
    calibrationLowValue: number | undefined;
    calibrationHighValue: number | undefined;
    sensorRange: number | undefined;
    isActive: boolean;
    masterDeviceId: number;
    shippedDate: moment.Moment;
    masterDevice: MasterDevice;
    tenant: AbpTenant;
}

export class MasterRtu implements IMasterRtu {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    tenantId!: number;
    rtuserialNumber!: string | undefined;
    isActive!: boolean;
    masterDeviceId!: number;
    shippedDate!: moment.Moment | undefined;
    startStream!: boolean;
    sendCellLogs!: boolean | undefined;
    setBatteryPercentage!: number | undefined;
    masterDevice!: MasterDevice;
    tenant!: AbpTenant;

    constructor(data?: IMasterRtu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.tenantId = data["tenantId"];
            this.rtuserialNumber = data["rtuserialNumber"];
            this.isActive = data["isActive"];
            this.masterDeviceId = data["masterDeviceId"];
            this.shippedDate = data["shippedDate"] ? moment(data["shippedDate"].toString()) : <any>undefined;
            this.startStream = data["startStream"];
            this.sendCellLogs = data["sendCellLogs"];
            this.setBatteryPercentage = data["setBatteryPercentage"];
            this.masterDevice = data["masterDevice"] ? MasterDevice.fromJS(data["masterDevice"]) : <any>undefined;
            this.tenant = data["tenant"] ? AbpTenant.fromJS(data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MasterRtu {
        data = typeof data === 'object' ? data : {};
        let result = new MasterRtu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["rtuserialNumber"] = this.rtuserialNumber;
        data["isActive"] = this.isActive;
        data["masterDeviceId"] = this.masterDeviceId;
        data["shippedDate"] = this.shippedDate ? this.shippedDate.toISOString() : <any>undefined;
        data["startStream"] = this.startStream;
        data["sendCellLogs"] = this.sendCellLogs;
        data["setBatteryPercentage"] = this.setBatteryPercentage;
        data["masterDevice"] = this.masterDevice ? this.masterDevice.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMasterRtu {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number;
    rtuserialNumber: string | undefined;
    isActive: boolean;
    masterDeviceId: number;
    shippedDate: moment.Moment | undefined;
    startStream: boolean;
    sendCellLogs: boolean | undefined;
    setBatteryPercentage: number | undefined;
    masterDevice: MasterDevice;
    tenant: AbpTenant;
}

export class MasterSensorDetailData implements IMasterSensorDetailData {
    id!: number;
    rtuserialNumber!: string | undefined;
    dataDateTime!: moment.Moment;
    pressure!: number | undefined;
    temperature!: number | undefined;
    relativeHumidity!: number | undefined;
    relativeHumidityOffset!: number | undefined;
    rawDifferentialPressure!: number | undefined;
    flowVelocity!: number | undefined;
    flowVolume!: number | undefined;
    flowMscfh!: number | undefined;
    vibration!: number | undefined;
    vibrationXAverage!: number | undefined;
    vibrationYAverage!: number | undefined;
    vibrationZAverage!: number | undefined;
    vibrationXRms!: number | undefined;
    vibrationYRms!: number | undefined;
    vibrationZRms!: number | undefined;
    isAlarm!: string | undefined;
    channelNum!: number;
    absolutePressure!: number | undefined;
    slamShut!: boolean | undefined;

    constructor(data?: IMasterSensorDetailData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.rtuserialNumber = data["rtuserialNumber"];
            this.dataDateTime = data["dataDateTime"] ? moment(data["dataDateTime"].toString()) : <any>undefined;
            this.pressure = data["pressure"];
            this.temperature = data["temperature"];
            this.relativeHumidity = data["relativeHumidity"];
            this.relativeHumidityOffset = data["relativeHumidityOffset"];
            this.rawDifferentialPressure = data["rawDifferentialPressure"];
            this.flowVelocity = data["flowVelocity"];
            this.flowVolume = data["flowVolume"];
            this.flowMscfh = data["flowMscfh"];
            this.vibration = data["vibration"];
            this.vibrationXAverage = data["vibrationXAverage"];
            this.vibrationYAverage = data["vibrationYAverage"];
            this.vibrationZAverage = data["vibrationZAverage"];
            this.vibrationXRms = data["vibrationXRms"];
            this.vibrationYRms = data["vibrationYRms"];
            this.vibrationZRms = data["vibrationZRms"];
            this.isAlarm = data["isAlarm"];
            this.channelNum = data["channelNum"];
            this.absolutePressure = data["absolutePressure"];
            this.slamShut = data["slamShut"];
        }
    }

    static fromJS(data: any): MasterSensorDetailData {
        data = typeof data === 'object' ? data : {};
        let result = new MasterSensorDetailData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rtuserialNumber"] = this.rtuserialNumber;
        data["dataDateTime"] = this.dataDateTime ? this.dataDateTime.toISOString() : <any>undefined;
        data["pressure"] = this.pressure;
        data["temperature"] = this.temperature;
        data["relativeHumidity"] = this.relativeHumidity;
        data["relativeHumidityOffset"] = this.relativeHumidityOffset;
        data["rawDifferentialPressure"] = this.rawDifferentialPressure;
        data["flowVelocity"] = this.flowVelocity;
        data["flowVolume"] = this.flowVolume;
        data["flowMscfh"] = this.flowMscfh;
        data["vibration"] = this.vibration;
        data["vibrationXAverage"] = this.vibrationXAverage;
        data["vibrationYAverage"] = this.vibrationYAverage;
        data["vibrationZAverage"] = this.vibrationZAverage;
        data["vibrationXRms"] = this.vibrationXRms;
        data["vibrationYRms"] = this.vibrationYRms;
        data["vibrationZRms"] = this.vibrationZRms;
        data["isAlarm"] = this.isAlarm;
        data["channelNum"] = this.channelNum;
        data["absolutePressure"] = this.absolutePressure;
        data["slamShut"] = this.slamShut;
        return data; 
    }
}

export interface IMasterSensorDetailData {
    id: number;
    rtuserialNumber: string | undefined;
    dataDateTime: moment.Moment;
    pressure: number | undefined;
    temperature: number | undefined;
    relativeHumidity: number | undefined;
    relativeHumidityOffset: number | undefined;
    rawDifferentialPressure: number | undefined;
    flowVelocity: number | undefined;
    flowVolume: number | undefined;
    flowMscfh: number | undefined;
    vibration: number | undefined;
    vibrationXAverage: number | undefined;
    vibrationYAverage: number | undefined;
    vibrationZAverage: number | undefined;
    vibrationXRms: number | undefined;
    vibrationYRms: number | undefined;
    vibrationZRms: number | undefined;
    isAlarm: string | undefined;
    channelNum: number;
    absolutePressure: number | undefined;
    slamShut: boolean | undefined;
}

export class MasterSensorSummaryData implements IMasterSensorSummaryData {
    id!: number;
    rtuserialNumber!: string | undefined;
    dataDateTime!: moment.Moment | undefined;
    batteryPercent!: number | undefined;
    signalStrength!: number | undefined;
    gpscoordinates!: string | undefined;
    firmwareVersion!: string | undefined;
    callTime!: moment.Moment | undefined;
    rowRead!: boolean;
    callType!: number;
    callSuccessful!: boolean;
    timezoneOffsetSeconds!: number | undefined;

    constructor(data?: IMasterSensorSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.rtuserialNumber = data["rtuserialNumber"];
            this.dataDateTime = data["dataDateTime"] ? moment(data["dataDateTime"].toString()) : <any>undefined;
            this.batteryPercent = data["batteryPercent"];
            this.signalStrength = data["signalStrength"];
            this.gpscoordinates = data["gpscoordinates"];
            this.firmwareVersion = data["firmwareVersion"];
            this.callTime = data["callTime"] ? moment(data["callTime"].toString()) : <any>undefined;
            this.rowRead = data["rowRead"];
            this.callType = data["callType"];
            this.callSuccessful = data["callSuccessful"];
            this.timezoneOffsetSeconds = data["timezoneOffsetSeconds"];
        }
    }

    static fromJS(data: any): MasterSensorSummaryData {
        data = typeof data === 'object' ? data : {};
        let result = new MasterSensorSummaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rtuserialNumber"] = this.rtuserialNumber;
        data["dataDateTime"] = this.dataDateTime ? this.dataDateTime.toISOString() : <any>undefined;
        data["batteryPercent"] = this.batteryPercent;
        data["signalStrength"] = this.signalStrength;
        data["gpscoordinates"] = this.gpscoordinates;
        data["firmwareVersion"] = this.firmwareVersion;
        data["callTime"] = this.callTime ? this.callTime.toISOString() : <any>undefined;
        data["rowRead"] = this.rowRead;
        data["callType"] = this.callType;
        data["callSuccessful"] = this.callSuccessful;
        data["timezoneOffsetSeconds"] = this.timezoneOffsetSeconds;
        return data; 
    }
}

export interface IMasterSensorSummaryData {
    id: number;
    rtuserialNumber: string | undefined;
    dataDateTime: moment.Moment | undefined;
    batteryPercent: number | undefined;
    signalStrength: number | undefined;
    gpscoordinates: string | undefined;
    firmwareVersion: string | undefined;
    callTime: moment.Moment | undefined;
    rowRead: boolean;
    callType: number;
    callSuccessful: boolean;
    timezoneOffsetSeconds: number | undefined;
}

export class SetBatteryPercentageInput implements ISetBatteryPercentageInput {
    rtuSerialNumber!: string | undefined;
    batteryPercentage!: number;

    constructor(data?: ISetBatteryPercentageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rtuSerialNumber = data["rtuSerialNumber"];
            this.batteryPercentage = data["batteryPercentage"];
        }
    }

    static fromJS(data: any): SetBatteryPercentageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetBatteryPercentageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rtuSerialNumber"] = this.rtuSerialNumber;
        data["batteryPercentage"] = this.batteryPercentage;
        return data; 
    }
}

export interface ISetBatteryPercentageInput {
    rtuSerialNumber: string | undefined;
    batteryPercentage: number;
}

export class Site implements ISite {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    tenantId!: number;
    rtuserialNumber!: string | undefined;
    siteName!: string | undefined;
    gpscoordinates!: string | undefined;
    ipaddress!: string | undefined;
    location!: string | undefined;
    callInFrequency!: number | undefined;
    sampleRate!: number | undefined;
    gasDensity!: number | undefined;
    batteryPercent!: number | undefined;
    signalStrength!: number | undefined;
    firmwareVersion!: string | undefined;
    isInAlarm!: boolean;
    alarmStateDate!: moment.Moment | undefined;
    alarmState!: string | undefined;
    alarmStateReason!: string | undefined;
    installDate!: moment.Moment | undefined;
    lastCallInDate!: moment.Moment | undefined;
    alarmStateChannel!: string | undefined;
    groupSites!: GroupSite[] | undefined;
    siteChannels!: SiteChannel[] | undefined;
    siteMeasurementConfigs!: SiteMeasurementConfig[] | undefined;
    siteUsers!: SiteUser[] | undefined;

    constructor(data?: ISite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.tenantId = data["tenantId"];
            this.rtuserialNumber = data["rtuserialNumber"];
            this.siteName = data["siteName"];
            this.gpscoordinates = data["gpscoordinates"];
            this.ipaddress = data["ipaddress"];
            this.location = data["location"];
            this.callInFrequency = data["callInFrequency"];
            this.sampleRate = data["sampleRate"];
            this.gasDensity = data["gasDensity"];
            this.batteryPercent = data["batteryPercent"];
            this.signalStrength = data["signalStrength"];
            this.firmwareVersion = data["firmwareVersion"];
            this.isInAlarm = data["isInAlarm"];
            this.alarmStateDate = data["alarmStateDate"] ? moment(data["alarmStateDate"].toString()) : <any>undefined;
            this.alarmState = data["alarmState"];
            this.alarmStateReason = data["alarmStateReason"];
            this.installDate = data["installDate"] ? moment(data["installDate"].toString()) : <any>undefined;
            this.lastCallInDate = data["lastCallInDate"] ? moment(data["lastCallInDate"].toString()) : <any>undefined;
            this.alarmStateChannel = data["alarmStateChannel"];
            if (Array.isArray(data["groupSites"])) {
                this.groupSites = [] as any;
                for (let item of data["groupSites"])
                    this.groupSites!.push(GroupSite.fromJS(item));
            }
            if (Array.isArray(data["siteChannels"])) {
                this.siteChannels = [] as any;
                for (let item of data["siteChannels"])
                    this.siteChannels!.push(SiteChannel.fromJS(item));
            }
            if (Array.isArray(data["siteMeasurementConfigs"])) {
                this.siteMeasurementConfigs = [] as any;
                for (let item of data["siteMeasurementConfigs"])
                    this.siteMeasurementConfigs!.push(SiteMeasurementConfig.fromJS(item));
            }
            if (Array.isArray(data["siteUsers"])) {
                this.siteUsers = [] as any;
                for (let item of data["siteUsers"])
                    this.siteUsers!.push(SiteUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Site {
        data = typeof data === 'object' ? data : {};
        let result = new Site();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["rtuserialNumber"] = this.rtuserialNumber;
        data["siteName"] = this.siteName;
        data["gpscoordinates"] = this.gpscoordinates;
        data["ipaddress"] = this.ipaddress;
        data["location"] = this.location;
        data["callInFrequency"] = this.callInFrequency;
        data["sampleRate"] = this.sampleRate;
        data["gasDensity"] = this.gasDensity;
        data["batteryPercent"] = this.batteryPercent;
        data["signalStrength"] = this.signalStrength;
        data["firmwareVersion"] = this.firmwareVersion;
        data["isInAlarm"] = this.isInAlarm;
        data["alarmStateDate"] = this.alarmStateDate ? this.alarmStateDate.toISOString() : <any>undefined;
        data["alarmState"] = this.alarmState;
        data["alarmStateReason"] = this.alarmStateReason;
        data["installDate"] = this.installDate ? this.installDate.toISOString() : <any>undefined;
        data["lastCallInDate"] = this.lastCallInDate ? this.lastCallInDate.toISOString() : <any>undefined;
        data["alarmStateChannel"] = this.alarmStateChannel;
        if (Array.isArray(this.groupSites)) {
            data["groupSites"] = [];
            for (let item of this.groupSites)
                data["groupSites"].push(item.toJSON());
        }
        if (Array.isArray(this.siteChannels)) {
            data["siteChannels"] = [];
            for (let item of this.siteChannels)
                data["siteChannels"].push(item.toJSON());
        }
        if (Array.isArray(this.siteMeasurementConfigs)) {
            data["siteMeasurementConfigs"] = [];
            for (let item of this.siteMeasurementConfigs)
                data["siteMeasurementConfigs"].push(item.toJSON());
        }
        if (Array.isArray(this.siteUsers)) {
            data["siteUsers"] = [];
            for (let item of this.siteUsers)
                data["siteUsers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISite {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number;
    rtuserialNumber: string | undefined;
    siteName: string | undefined;
    gpscoordinates: string | undefined;
    ipaddress: string | undefined;
    location: string | undefined;
    callInFrequency: number | undefined;
    sampleRate: number | undefined;
    gasDensity: number | undefined;
    batteryPercent: number | undefined;
    signalStrength: number | undefined;
    firmwareVersion: string | undefined;
    isInAlarm: boolean;
    alarmStateDate: moment.Moment | undefined;
    alarmState: string | undefined;
    alarmStateReason: string | undefined;
    installDate: moment.Moment | undefined;
    lastCallInDate: moment.Moment | undefined;
    alarmStateChannel: string | undefined;
    groupSites: GroupSite[] | undefined;
    siteChannels: SiteChannel[] | undefined;
    siteMeasurementConfigs: SiteMeasurementConfig[] | undefined;
    siteUsers: SiteUser[] | undefined;
}

export class SiteChannel implements ISiteChannel {
    id!: number;
    tenantId!: number;
    channelNumber!: number;
    channelNickname!: string | undefined;
    channelPipeDiameter!: number | undefined;
    siteId!: number;
    site!: Site;
    siteData!: SiteData[] | undefined;
    siteMeasurementConfigs!: SiteMeasurementConfig[] | undefined;
    siteUsersAlarms!: SiteUsersAlarm[] | undefined;

    constructor(data?: ISiteChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.channelNumber = data["channelNumber"];
            this.channelNickname = data["channelNickname"];
            this.channelPipeDiameter = data["channelPipeDiameter"];
            this.siteId = data["siteId"];
            this.site = data["site"] ? Site.fromJS(data["site"]) : <any>undefined;
            if (Array.isArray(data["siteData"])) {
                this.siteData = [] as any;
                for (let item of data["siteData"])
                    this.siteData!.push(SiteData.fromJS(item));
            }
            if (Array.isArray(data["siteMeasurementConfigs"])) {
                this.siteMeasurementConfigs = [] as any;
                for (let item of data["siteMeasurementConfigs"])
                    this.siteMeasurementConfigs!.push(SiteMeasurementConfig.fromJS(item));
            }
            if (Array.isArray(data["siteUsersAlarms"])) {
                this.siteUsersAlarms = [] as any;
                for (let item of data["siteUsersAlarms"])
                    this.siteUsersAlarms!.push(SiteUsersAlarm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SiteChannel {
        data = typeof data === 'object' ? data : {};
        let result = new SiteChannel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["channelNumber"] = this.channelNumber;
        data["channelNickname"] = this.channelNickname;
        data["channelPipeDiameter"] = this.channelPipeDiameter;
        data["siteId"] = this.siteId;
        data["site"] = this.site ? this.site.toJSON() : <any>undefined;
        if (Array.isArray(this.siteData)) {
            data["siteData"] = [];
            for (let item of this.siteData)
                data["siteData"].push(item.toJSON());
        }
        if (Array.isArray(this.siteMeasurementConfigs)) {
            data["siteMeasurementConfigs"] = [];
            for (let item of this.siteMeasurementConfigs)
                data["siteMeasurementConfigs"].push(item.toJSON());
        }
        if (Array.isArray(this.siteUsersAlarms)) {
            data["siteUsersAlarms"] = [];
            for (let item of this.siteUsersAlarms)
                data["siteUsersAlarms"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISiteChannel {
    id: number;
    tenantId: number;
    channelNumber: number;
    channelNickname: string | undefined;
    channelPipeDiameter: number | undefined;
    siteId: number;
    site: Site;
    siteData: SiteData[] | undefined;
    siteMeasurementConfigs: SiteMeasurementConfig[] | undefined;
    siteUsersAlarms: SiteUsersAlarm[] | undefined;
}

export class SiteChannelDelete implements ISiteChannelDelete {
    rtuSerialNumber!: string | undefined;
    channelNum!: number;

    constructor(data?: ISiteChannelDelete) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rtuSerialNumber = data["rtuSerialNumber"];
            this.channelNum = data["channelNum"];
        }
    }

    static fromJS(data: any): SiteChannelDelete {
        data = typeof data === 'object' ? data : {};
        let result = new SiteChannelDelete();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rtuSerialNumber"] = this.rtuSerialNumber;
        data["channelNum"] = this.channelNum;
        return data; 
    }
}

export interface ISiteChannelDelete {
    rtuSerialNumber: string | undefined;
    channelNum: number;
}

export class SiteChannelTimeDelete implements ISiteChannelTimeDelete {
    rtuSerialNumber!: string | undefined;
    channelNum!: number;
    dtTime!: moment.Moment;

    constructor(data?: ISiteChannelTimeDelete) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rtuSerialNumber = data["rtuSerialNumber"];
            this.channelNum = data["channelNum"];
            this.dtTime = data["dtTime"] ? moment(data["dtTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SiteChannelTimeDelete {
        data = typeof data === 'object' ? data : {};
        let result = new SiteChannelTimeDelete();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rtuSerialNumber"] = this.rtuSerialNumber;
        data["channelNum"] = this.channelNum;
        data["dtTime"] = this.dtTime ? this.dtTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ISiteChannelTimeDelete {
    rtuSerialNumber: string | undefined;
    channelNum: number;
    dtTime: moment.Moment;
}

export class SiteData implements ISiteData {
    id!: number;
    tenantId!: number;
    dataDateTime!: moment.Moment;
    pressure!: number | undefined;
    temperature!: number | undefined;
    relativeHumidity!: number | undefined;
    relativeHumidityOffset!: number | undefined;
    rawDifferentialPressure!: number | undefined;
    flowVelocity!: number | undefined;
    flowVolume!: number | undefined;
    flowMscfh!: number | undefined;
    vibration!: number | undefined;
    vibrationXAverage!: number | undefined;
    vibrationYAverage!: number | undefined;
    vibrationZAverage!: number | undefined;
    vibrationXRms!: number | undefined;
    vibrationYRms!: number | undefined;
    vibrationZRms!: number | undefined;
    isAlarm!: string | undefined;
    batteryPercent!: number | undefined;
    signalStrength!: number | undefined;
    flowVelocityOrig!: number | undefined;
    flowVolumeOrig!: number | undefined;
    pressureOrig!: number | undefined;
    relativeHumidityOrig!: number | undefined;
    temperatureOrig!: number | undefined;
    vibrationOrig!: number | undefined;
    siteChannelId!: number;
    absolutePressure!: number | undefined;
    siteChannel!: SiteChannel;

    constructor(data?: ISiteData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.dataDateTime = data["dataDateTime"] ? moment(data["dataDateTime"].toString()) : <any>undefined;
            this.pressure = data["pressure"];
            this.temperature = data["temperature"];
            this.relativeHumidity = data["relativeHumidity"];
            this.relativeHumidityOffset = data["relativeHumidityOffset"];
            this.rawDifferentialPressure = data["rawDifferentialPressure"];
            this.flowVelocity = data["flowVelocity"];
            this.flowVolume = data["flowVolume"];
            this.flowMscfh = data["flowMscfh"];
            this.vibration = data["vibration"];
            this.vibrationXAverage = data["vibrationXAverage"];
            this.vibrationYAverage = data["vibrationYAverage"];
            this.vibrationZAverage = data["vibrationZAverage"];
            this.vibrationXRms = data["vibrationXRms"];
            this.vibrationYRms = data["vibrationYRms"];
            this.vibrationZRms = data["vibrationZRms"];
            this.isAlarm = data["isAlarm"];
            this.batteryPercent = data["batteryPercent"];
            this.signalStrength = data["signalStrength"];
            this.flowVelocityOrig = data["flowVelocityOrig"];
            this.flowVolumeOrig = data["flowVolumeOrig"];
            this.pressureOrig = data["pressureOrig"];
            this.relativeHumidityOrig = data["relativeHumidityOrig"];
            this.temperatureOrig = data["temperatureOrig"];
            this.vibrationOrig = data["vibrationOrig"];
            this.siteChannelId = data["siteChannelId"];
            this.absolutePressure = data["absolutePressure"];
            this.siteChannel = data["siteChannel"] ? SiteChannel.fromJS(data["siteChannel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SiteData {
        data = typeof data === 'object' ? data : {};
        let result = new SiteData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["dataDateTime"] = this.dataDateTime ? this.dataDateTime.toISOString() : <any>undefined;
        data["pressure"] = this.pressure;
        data["temperature"] = this.temperature;
        data["relativeHumidity"] = this.relativeHumidity;
        data["relativeHumidityOffset"] = this.relativeHumidityOffset;
        data["rawDifferentialPressure"] = this.rawDifferentialPressure;
        data["flowVelocity"] = this.flowVelocity;
        data["flowVolume"] = this.flowVolume;
        data["flowMscfh"] = this.flowMscfh;
        data["vibration"] = this.vibration;
        data["vibrationXAverage"] = this.vibrationXAverage;
        data["vibrationYAverage"] = this.vibrationYAverage;
        data["vibrationZAverage"] = this.vibrationZAverage;
        data["vibrationXRms"] = this.vibrationXRms;
        data["vibrationYRms"] = this.vibrationYRms;
        data["vibrationZRms"] = this.vibrationZRms;
        data["isAlarm"] = this.isAlarm;
        data["batteryPercent"] = this.batteryPercent;
        data["signalStrength"] = this.signalStrength;
        data["flowVelocityOrig"] = this.flowVelocityOrig;
        data["flowVolumeOrig"] = this.flowVolumeOrig;
        data["pressureOrig"] = this.pressureOrig;
        data["relativeHumidityOrig"] = this.relativeHumidityOrig;
        data["temperatureOrig"] = this.temperatureOrig;
        data["vibrationOrig"] = this.vibrationOrig;
        data["siteChannelId"] = this.siteChannelId;
        data["absolutePressure"] = this.absolutePressure;
        data["siteChannel"] = this.siteChannel ? this.siteChannel.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISiteData {
    id: number;
    tenantId: number;
    dataDateTime: moment.Moment;
    pressure: number | undefined;
    temperature: number | undefined;
    relativeHumidity: number | undefined;
    relativeHumidityOffset: number | undefined;
    rawDifferentialPressure: number | undefined;
    flowVelocity: number | undefined;
    flowVolume: number | undefined;
    flowMscfh: number | undefined;
    vibration: number | undefined;
    vibrationXAverage: number | undefined;
    vibrationYAverage: number | undefined;
    vibrationZAverage: number | undefined;
    vibrationXRms: number | undefined;
    vibrationYRms: number | undefined;
    vibrationZRms: number | undefined;
    isAlarm: string | undefined;
    batteryPercent: number | undefined;
    signalStrength: number | undefined;
    flowVelocityOrig: number | undefined;
    flowVolumeOrig: number | undefined;
    pressureOrig: number | undefined;
    relativeHumidityOrig: number | undefined;
    temperatureOrig: number | undefined;
    vibrationOrig: number | undefined;
    siteChannelId: number;
    absolutePressure: number | undefined;
    siteChannel: SiteChannel;
}

export class SiteMeasurementConfig implements ISiteMeasurementConfig {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    tenantId!: number;
    measurement!: string | undefined;
    enabled!: boolean;
    applyFormulaId!: number | undefined;
    lowLowAlarm!: number | undefined;
    lowAlarm!: number | undefined;
    nominal!: number | undefined;
    highAlarm!: number | undefined;
    highHighAlarm!: number | undefined;
    siteId!: number;
    unit!: string | undefined;
    siteChannelId!: number;
    site!: Site;
    siteChannel!: SiteChannel;

    constructor(data?: ISiteMeasurementConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.tenantId = data["tenantId"];
            this.measurement = data["measurement"];
            this.enabled = data["enabled"];
            this.applyFormulaId = data["applyFormulaId"];
            this.lowLowAlarm = data["lowLowAlarm"];
            this.lowAlarm = data["lowAlarm"];
            this.nominal = data["nominal"];
            this.highAlarm = data["highAlarm"];
            this.highHighAlarm = data["highHighAlarm"];
            this.siteId = data["siteId"];
            this.unit = data["unit"];
            this.siteChannelId = data["siteChannelId"];
            this.site = data["site"] ? Site.fromJS(data["site"]) : <any>undefined;
            this.siteChannel = data["siteChannel"] ? SiteChannel.fromJS(data["siteChannel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SiteMeasurementConfig {
        data = typeof data === 'object' ? data : {};
        let result = new SiteMeasurementConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["measurement"] = this.measurement;
        data["enabled"] = this.enabled;
        data["applyFormulaId"] = this.applyFormulaId;
        data["lowLowAlarm"] = this.lowLowAlarm;
        data["lowAlarm"] = this.lowAlarm;
        data["nominal"] = this.nominal;
        data["highAlarm"] = this.highAlarm;
        data["highHighAlarm"] = this.highHighAlarm;
        data["siteId"] = this.siteId;
        data["unit"] = this.unit;
        data["siteChannelId"] = this.siteChannelId;
        data["site"] = this.site ? this.site.toJSON() : <any>undefined;
        data["siteChannel"] = this.siteChannel ? this.siteChannel.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISiteMeasurementConfig {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number;
    measurement: string | undefined;
    enabled: boolean;
    applyFormulaId: number | undefined;
    lowLowAlarm: number | undefined;
    lowAlarm: number | undefined;
    nominal: number | undefined;
    highAlarm: number | undefined;
    highHighAlarm: number | undefined;
    siteId: number;
    unit: string | undefined;
    siteChannelId: number;
    site: Site;
    siteChannel: SiteChannel;
}

export class SiteUser implements ISiteUser {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    tenantId!: number;
    role!: string | undefined;
    alertMethods!: string | undefined;
    alertFrequency!: string | undefined;
    alertClosure!: boolean;
    receiveMissedCallIns!: boolean;
    callInFreq!: string | undefined;
    callInOcc!: string | undefined;
    receiveSensorData!: boolean;
    sensorFreq!: string | undefined;
    sensorOcc!: string | undefined;
    siteId!: number;
    userId!: number;
    receiveAlarmNotification!: boolean | undefined;
    site!: Site;
    user!: AbpUser;
    siteUsersAlarms!: SiteUsersAlarm[] | undefined;

    constructor(data?: ISiteUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.tenantId = data["tenantId"];
            this.role = data["role"];
            this.alertMethods = data["alertMethods"];
            this.alertFrequency = data["alertFrequency"];
            this.alertClosure = data["alertClosure"];
            this.receiveMissedCallIns = data["receiveMissedCallIns"];
            this.callInFreq = data["callInFreq"];
            this.callInOcc = data["callInOcc"];
            this.receiveSensorData = data["receiveSensorData"];
            this.sensorFreq = data["sensorFreq"];
            this.sensorOcc = data["sensorOcc"];
            this.siteId = data["siteId"];
            this.userId = data["userId"];
            this.receiveAlarmNotification = data["receiveAlarmNotification"];
            this.site = data["site"] ? Site.fromJS(data["site"]) : <any>undefined;
            this.user = data["user"] ? AbpUser.fromJS(data["user"]) : <any>undefined;
            if (Array.isArray(data["siteUsersAlarms"])) {
                this.siteUsersAlarms = [] as any;
                for (let item of data["siteUsersAlarms"])
                    this.siteUsersAlarms!.push(SiteUsersAlarm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SiteUser {
        data = typeof data === 'object' ? data : {};
        let result = new SiteUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["role"] = this.role;
        data["alertMethods"] = this.alertMethods;
        data["alertFrequency"] = this.alertFrequency;
        data["alertClosure"] = this.alertClosure;
        data["receiveMissedCallIns"] = this.receiveMissedCallIns;
        data["callInFreq"] = this.callInFreq;
        data["callInOcc"] = this.callInOcc;
        data["receiveSensorData"] = this.receiveSensorData;
        data["sensorFreq"] = this.sensorFreq;
        data["sensorOcc"] = this.sensorOcc;
        data["siteId"] = this.siteId;
        data["userId"] = this.userId;
        data["receiveAlarmNotification"] = this.receiveAlarmNotification;
        data["site"] = this.site ? this.site.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.siteUsersAlarms)) {
            data["siteUsersAlarms"] = [];
            for (let item of this.siteUsersAlarms)
                data["siteUsersAlarms"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISiteUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number;
    role: string | undefined;
    alertMethods: string | undefined;
    alertFrequency: string | undefined;
    alertClosure: boolean;
    receiveMissedCallIns: boolean;
    callInFreq: string | undefined;
    callInOcc: string | undefined;
    receiveSensorData: boolean;
    sensorFreq: string | undefined;
    sensorOcc: string | undefined;
    siteId: number;
    userId: number;
    receiveAlarmNotification: boolean | undefined;
    site: Site;
    user: AbpUser;
    siteUsersAlarms: SiteUsersAlarm[] | undefined;
}

export class SiteUsersAlarm implements ISiteUsersAlarm {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    tenantId!: number;
    role!: string | undefined;
    measurement!: string | undefined;
    recLowLow!: boolean;
    recLow!: boolean;
    recHigh!: boolean;
    recHighHigh!: boolean;
    siteUserId!: number;
    siteChannelId!: number;
    siteChannel!: SiteChannel;
    siteUser!: SiteUser;

    constructor(data?: ISiteUsersAlarm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.tenantId = data["tenantId"];
            this.role = data["role"];
            this.measurement = data["measurement"];
            this.recLowLow = data["recLowLow"];
            this.recLow = data["recLow"];
            this.recHigh = data["recHigh"];
            this.recHighHigh = data["recHighHigh"];
            this.siteUserId = data["siteUserId"];
            this.siteChannelId = data["siteChannelId"];
            this.siteChannel = data["siteChannel"] ? SiteChannel.fromJS(data["siteChannel"]) : <any>undefined;
            this.siteUser = data["siteUser"] ? SiteUser.fromJS(data["siteUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SiteUsersAlarm {
        data = typeof data === 'object' ? data : {};
        let result = new SiteUsersAlarm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["role"] = this.role;
        data["measurement"] = this.measurement;
        data["recLowLow"] = this.recLowLow;
        data["recLow"] = this.recLow;
        data["recHigh"] = this.recHigh;
        data["recHighHigh"] = this.recHighHigh;
        data["siteUserId"] = this.siteUserId;
        data["siteChannelId"] = this.siteChannelId;
        data["siteChannel"] = this.siteChannel ? this.siteChannel.toJSON() : <any>undefined;
        data["siteUser"] = this.siteUser ? this.siteUser.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISiteUsersAlarm {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number;
    role: string | undefined;
    measurement: string | undefined;
    recLowLow: boolean;
    recLow: boolean;
    recHigh: boolean;
    recHighHigh: boolean;
    siteUserId: number;
    siteChannelId: number;
    siteChannel: SiteChannel;
    siteUser: SiteUser;
}

export class ToggleSendLogsInput implements IToggleSendLogsInput {
    serialNumber!: string | undefined;
    bSendCellLogs!: boolean;

    constructor(data?: IToggleSendLogsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serialNumber = data["serialNumber"];
            this.bSendCellLogs = data["bSendCellLogs"];
        }
    }

    static fromJS(data: any): ToggleSendLogsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleSendLogsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["bSendCellLogs"] = this.bSendCellLogs;
        return data; 
    }
}

export interface IToggleSendLogsInput {
    serialNumber: string | undefined;
    bSendCellLogs: boolean;
}

export class ToggleStreamInput implements IToggleStreamInput {

    constructor(data?: IToggleStreamInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): ToggleStreamInput {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleStreamInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IToggleStreamInput {
}

export class UserAdditionalPhone implements IUserAdditionalPhone {
    id!: number;
    phoneNumber!: string | undefined;
    phoneType!: string | undefined;
    receiveSms!: boolean;
    userId!: number;
    user!: AbpUser;

    constructor(data?: IUserAdditionalPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.phoneNumber = data["phoneNumber"];
            this.phoneType = data["phoneType"];
            this.receiveSms = data["receiveSms"];
            this.userId = data["userId"];
            this.user = data["user"] ? AbpUser.fromJS(data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserAdditionalPhone {
        data = typeof data === 'object' ? data : {};
        let result = new UserAdditionalPhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneType"] = this.phoneType;
        data["receiveSms"] = this.receiveSms;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUserAdditionalPhone {
    id: number;
    phoneNumber: string | undefined;
    phoneType: string | undefined;
    receiveSms: boolean;
    userId: number;
    user: AbpUser;
}

export class UserOldPassword implements IUserOldPassword {
    id!: number;
    oldPassword!: string | undefined;
    userId!: number;
    user!: AbpUser;

    constructor(data?: IUserOldPassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.oldPassword = data["oldPassword"];
            this.userId = data["userId"];
            this.user = data["user"] ? AbpUser.fromJS(data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserOldPassword {
        data = typeof data === 'object' ? data : {};
        let result = new UserOldPassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["oldPassword"] = this.oldPassword;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUserOldPassword {
    id: number;
    oldPassword: string | undefined;
    userId: number;
    user: AbpUser;
}

export class VwGetDevice implements IVwGetDevice {
    id!: number;
    deviceType!: string | undefined;
    productType!: string | undefined;
    hardwareRevision!: string | undefined;
    isActive!: boolean;
    creationTime!: moment.Moment;
    activeFirmwareVersion!: string | undefined;

    constructor(data?: IVwGetDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.deviceType = data["deviceType"];
            this.productType = data["productType"];
            this.hardwareRevision = data["hardwareRevision"];
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.activeFirmwareVersion = data["activeFirmwareVersion"];
        }
    }

    static fromJS(data: any): VwGetDevice {
        data = typeof data === 'object' ? data : {};
        let result = new VwGetDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceType"] = this.deviceType;
        data["productType"] = this.productType;
        data["hardwareRevision"] = this.hardwareRevision;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["activeFirmwareVersion"] = this.activeFirmwareVersion;
        return data; 
    }
}

export interface IVwGetDevice {
    id: number;
    deviceType: string | undefined;
    productType: string | undefined;
    hardwareRevision: string | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    activeFirmwareVersion: string | undefined;
}

export class VwGetMasterMeter implements IVwGetMasterMeter {
    id!: number;
    meterSerialNumber!: string | undefined;
    calibrationLowValue!: number | undefined;
    calibrationHighValue!: number | undefined;
    shippedDate!: moment.Moment;
    sensorRange!: number | undefined;
    isActive!: boolean;
    masterDeviceProductType!: string | undefined;
    masterDeviceHardwareRevision!: string | undefined;
    masterDeviceFirmwareVersion!: string | undefined;
    tenantId!: number;

    constructor(data?: IVwGetMasterMeter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.meterSerialNumber = data["meterSerialNumber"];
            this.calibrationLowValue = data["calibrationLowValue"];
            this.calibrationHighValue = data["calibrationHighValue"];
            this.shippedDate = data["shippedDate"] ? moment(data["shippedDate"].toString()) : <any>undefined;
            this.sensorRange = data["sensorRange"];
            this.isActive = data["isActive"];
            this.masterDeviceProductType = data["masterDeviceProductType"];
            this.masterDeviceHardwareRevision = data["masterDeviceHardwareRevision"];
            this.masterDeviceFirmwareVersion = data["masterDeviceFirmwareVersion"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): VwGetMasterMeter {
        data = typeof data === 'object' ? data : {};
        let result = new VwGetMasterMeter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meterSerialNumber"] = this.meterSerialNumber;
        data["calibrationLowValue"] = this.calibrationLowValue;
        data["calibrationHighValue"] = this.calibrationHighValue;
        data["shippedDate"] = this.shippedDate ? this.shippedDate.toISOString() : <any>undefined;
        data["sensorRange"] = this.sensorRange;
        data["isActive"] = this.isActive;
        data["masterDeviceProductType"] = this.masterDeviceProductType;
        data["masterDeviceHardwareRevision"] = this.masterDeviceHardwareRevision;
        data["masterDeviceFirmwareVersion"] = this.masterDeviceFirmwareVersion;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IVwGetMasterMeter {
    id: number;
    meterSerialNumber: string | undefined;
    calibrationLowValue: number | undefined;
    calibrationHighValue: number | undefined;
    shippedDate: moment.Moment;
    sensorRange: number | undefined;
    isActive: boolean;
    masterDeviceProductType: string | undefined;
    masterDeviceHardwareRevision: string | undefined;
    masterDeviceFirmwareVersion: string | undefined;
    tenantId: number;
}

export class VwGetMasterRtu implements IVwGetMasterRtu {
    id!: number;
    rtuserialNumber!: string | undefined;
    shippedDate!: moment.Moment | undefined;
    isActive!: boolean;
    masterDeviceProductType!: string | undefined;
    masterDeviceHardwareRevision!: string | undefined;
    masterDeviceFirmwareVersion!: string | undefined;
    tenantId!: number;
    sendCellLogs!: boolean | undefined;

    constructor(data?: IVwGetMasterRtu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.rtuserialNumber = data["rtuserialNumber"];
            this.shippedDate = data["shippedDate"] ? moment(data["shippedDate"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.masterDeviceProductType = data["masterDeviceProductType"];
            this.masterDeviceHardwareRevision = data["masterDeviceHardwareRevision"];
            this.masterDeviceFirmwareVersion = data["masterDeviceFirmwareVersion"];
            this.tenantId = data["tenantId"];
            this.sendCellLogs = data["sendCellLogs"];
        }
    }

    static fromJS(data: any): VwGetMasterRtu {
        data = typeof data === 'object' ? data : {};
        let result = new VwGetMasterRtu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rtuserialNumber"] = this.rtuserialNumber;
        data["shippedDate"] = this.shippedDate ? this.shippedDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["masterDeviceProductType"] = this.masterDeviceProductType;
        data["masterDeviceHardwareRevision"] = this.masterDeviceHardwareRevision;
        data["masterDeviceFirmwareVersion"] = this.masterDeviceFirmwareVersion;
        data["tenantId"] = this.tenantId;
        data["sendCellLogs"] = this.sendCellLogs;
        return data; 
    }
}

export interface IVwGetMasterRtu {
    id: number;
    rtuserialNumber: string | undefined;
    shippedDate: moment.Moment | undefined;
    isActive: boolean;
    masterDeviceProductType: string | undefined;
    masterDeviceHardwareRevision: string | undefined;
    masterDeviceFirmwareVersion: string | undefined;
    tenantId: number;
    sendCellLogs: boolean | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}